/* GENERATED by scripts/sync-core.mjs from ../BirthdayTribute/index.html — do not edit here.
   1640 lines of the proven logic core (UMD IIFE) exported as an ES module. */
/* eslint-disable */
// @ts-nocheck
const module = { exports: {} };

(function (root) {
  "use strict";

  // -------------------- constants --------------------
  var TYPES = ["video", "written", "voice", "photo", "song"];
  // 🎵 Favorite Songs is RETIRED from the UI (owner request, 2026-07-24). The engine
  // (parseSong/songsList), the 'song' type, and any existing song data stay dormant —
  // flip this to true to restore the whole feature (picker tile, reveal section, filter chip).
  var SONGS_ON = false;
  // ▶ Quick highlight reel is RETIRED from the UI (owner request, 2026-09-15) — the tile
  // gallery's play-through replaced it. HighlightReel stays dormant; flip to restore.
  var REEL_ON = false;
  // 📡 Live party wall, the 🎬 cinematic Ceremony, the 🖼 Memory Wall and the generated ambient
  // music are RETIRED from the reveal (owner request, 2026-09-22): the tile board + the trailer
  // player cover them. Engines stay dormant behind these flags.
  var WALL_ON = false;
  var CEREMONY_ON = false;
  var MEMWALL_ON = false;
  var AMBIENT_ON = false;
  // The reading sections under the board (opening narration, Life timeline, Messages & Wishes
  // gallery, the essay) are RETIRED too (2026-09-22): the board + players are the reveal, and
  // 🎵 The Songs is the only section kept below it.
  var GALLERY_SECTIONS_ON = false;
  // 🎞 Animate photos (Replicate "living photos") is RETIRED (owner request, 2026-09-22): the
  // admin card is hidden and the reveal shows stills. Existing clips + the animate-photo
  // Edge Function stay untouched; flip this to bring it back.
  var ANIMATE_ON = false;
  var STATUS = ["pending", "approved", "rejected"];
  var TYPE_META = {
    video:   { label: "Video",   icon: "🎥", verb: "message" },
    written: { label: "Written", icon: "✍️", verb: "note" },
    voice:   { label: "Voice",   icon: "🎙️", verb: "message" },
    photo:   { label: "Photos",  icon: "📷", verb: "" },
    song:    { label: "Song",    icon: "🎵", verb: "" },
  };
  // Client-side guards (bytes / chars / seconds / count). Enforced before an upload starts.
  var LIMITS = {
    textMax: 2000,
    videoMB: 60,   // keeps storage/bandwidth sane on a family-scale backend
    audioMB: 25,
    photoMB: 10,
    maxPhotos: 10,
    recSecs: 180, // 3 minutes
  };
  var MB = 1024 * 1024;

  // -------------------- tiny utils --------------------
  // 2026-10-12 hardening (patched here, NOT in BirthdayTribute — tests/secure-ids.test.ts fails if sync-core reverts it):
  // ids and the reveal token come from the platform CSPRNG. Both alphabets have 32 symbols, so a byte modulo 32 is unbiased.
  function rbytes(n) { var u = new Uint8Array(n); (typeof crypto !== "undefined" ? crypto : globalThis.crypto).getRandomValues(u); return u; }
  function uid() { var c = "abcdefghijklmnopqrstuvwxyz234567", s = "", b = rbytes(12); for (var i = 0; i < 12; i++) s += c[b[i] & 31]; return s; }
  function token() { // non-guessable reveal id: 22 symbols × 5 bits = 110 bits
    var c = "abcdefghijkmnpqrstuvwxyz23456789", s = "", b = rbytes(22);
    for (var i = 0; i < 22; i++) s += c[b[i] & 31];
    return s;
  }
  function now() { return Date.now(); }
  function clone(x) { return x == null ? x : JSON.parse(JSON.stringify(x)); }
  function isBlank(s) { return !s || !String(s).trim(); }
  function hash(s) { var h = 5381; s = String(s); for (var i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) >>> 0; return h.toString(16); }

  // -------------------- default document --------------------
  function defaultConfig() {
    return {
      honoreeName: "John Truchel Sr.",    // used in copy
      displayName: "John Truchel Sr.",    // big reveal name; falls back to honoreeName
      occasion: "birthday",               // birthday | retirement | anniversary | memorial (theme + copy)
      age: 80,
      occasionTitle: "",                  // optional custom reveal headline
      introText: "We're collecting birthday wishes for a very special 80th.\nWhether he's known to you as John, JT, Dad, Pop-Pop, or Pops, let him know how much you care about him on his day.",
      thankYouText: "",                   // optional custom confirmation copy
      eventDate: "2026-09-28",
      headerPhotoUrl: "",                 // reveal portrait
      published: false,
      revealAt: "",                       // ISO datetime; reveal stays behind a countdown until then (optional)
      milestones: [],                     // "This Is Your Life" timeline: [{id,year,title,note,photoUrl,mediaKind}]
                                          // mediaKind: "photo" (default/absent) | "video" — an animated portrait
      narration: "",                      // AI-written reveal opening (organizer-generated)
      aiEnabled: false,                   // on once the ai-assist Edge Function is deployed; gates reveal translation
      story: null,                        // AI Story Director: {opening,closing,chapters:[{title,intro,ids}]}
      reaction: null,                     // "the moment he saw it": {kind:"video"|"voice", url, at}
      animations: {},                     // { [photoUrl]: clipUrl } -- animated "living photo" versions
      essay: "",                          // AI-woven tribute essay
      revealToken: "",                    // set by _ensureDoc
      groups: [],                         // ordered category labels for the reveal
      submitClosed: false,
      adminPassword: "birthday80",        // MOCK ONLY. Supabase mode uses real Auth.
      createdAt: now(),
    };
  }
  function blank() {
    return { config: defaultConfig(), submissions: {}, media: {}, meta: {} };
  }

  // -------------------- pure validation --------------------
  function validateGuest(g) {
    var errs = [];
    if (!g || isBlank(g.name)) errs.push("Please tell us your name.");
    if (g && g.name && g.name.length > 80) errs.push("That name is a little long.");
    return { ok: errs.length === 0, errors: errs };
  }
  // An "item" = one content piece a guest is composing (before it becomes a submission).
  // { type, text?, media:[{kind,url,filename,size,caption}] }
  function validateItem(item) {
    var errs = [];
    if (!item || TYPES.indexOf(item.type) < 0) { errs.push("Pick a message type."); return { ok: false, errors: errs }; }
    if (item.type === "written") {
      if (isBlank(item.text)) errs.push("Write a little something first.");
      else if (item.text.length > LIMITS.textMax) errs.push("Message is over " + LIMITS.textMax + " characters.");
    } else if (item.type === "photo") {
      var ph = (item.media || []).filter(function (m) { return m && (m.url || m.path); });   // private-bucket uploads carry a path and no public url (2026-10-11)
      if (!ph.length) errs.push("Add at least one photo.");
      if (ph.length > LIMITS.maxPhotos) errs.push("Up to " + LIMITS.maxPhotos + " photos at a time.");
    } else if (item.type === "song") {
      if (isBlank(item.text)) errs.push("Add the song name.");
    } else { // video or voice
      var m0 = (item.media || [])[0];
      if (!m0 || !(m0.url || m0.path)) errs.push("Record or upload your " + item.type + " message.");
    }
    return { ok: errs.length === 0, errors: errs };
  }
  function fileSizeOk(type, bytes) {
    if (type === "video") return bytes <= LIMITS.videoMB * MB;
    if (type === "voice") return bytes <= LIMITS.audioMB * MB;
    if (type === "photo") return bytes <= LIMITS.photoMB * MB;
    return true;
  }

  // -------------------- status transitions --------------------
  // Admin may move a submission between any of pending/approved/rejected freely.
  function canTransition(from, to) {
    return STATUS.indexOf(from) >= 0 && STATUS.indexOf(to) >= 0;
  }

  // -------------------- ordering & grouping (pure) --------------------
  function hydrate(doc, sub) {
    var media = (sub.mediaIds || []).map(function (id) { return doc.media[id]; }).filter(Boolean);
    return Object.assign({}, sub, { media: media });
  }
  function approvedSubs(doc) {
    return Object.keys(doc.submissions).map(function (k) { return doc.submissions[k]; })
      .filter(function (s) { return s.status === "approved"; });
  }
  // Sort within a group: featured first, then manual `order` (asc), then oldest first.
  function sortItems(list) {
    return list.slice().sort(function (a, b) {
      if (!!b.featured !== !!a.featured) return b.featured ? 1 : -1;
      var ao = a.order == null ? 1e9 : a.order, bo = b.order == null ? 1e9 : b.order;
      if (ao !== bo) return ao - bo;
      return (a.createdAt || 0) - (b.createdAt || 0);
    });
  }
  // Group approved submissions by their `group` label. Config.groups sets the order;
  // any extra groups follow alphabetically; ungrouped items collect under "" (rendered last).
  function groupApproved(doc) {
    var subs = approvedSubs(doc).filter(function (s) { return s.type !== "song"; }).map(function (s) { return hydrate(doc, s); });
    var byGroup = {};
    subs.forEach(function (s) { var g = s.group || ""; (byGroup[g] = byGroup[g] || []).push(s); });
    var order = (doc.config.groups || []).slice();
    Object.keys(byGroup).forEach(function (g) { if (g && order.indexOf(g) < 0) order.push(g); });
    order.sort(function (a, b) { // preserve config order, but push config-listed first
      var ia = (doc.config.groups || []).indexOf(a), ib = (doc.config.groups || []).indexOf(b);
      if (ia >= 0 && ib >= 0) return ia - ib;
      if (ia >= 0) return -1; if (ib >= 0) return 1;
      return a.localeCompare(b);
    });
    var out = [];
    order.forEach(function (g) { if (byGroup[g]) out.push({ name: g, items: sortItems(byGroup[g]) }); });
    if (byGroup[""]) out.push({ name: "", items: sortItems(byGroup[""]) });
    return out;
  }
  // Flat, ordered list of every approved message (for the slideshow / highlight reel).
  function revealMessages(doc) {
    var groups = groupApproved(doc), out = [];
    groups.forEach(function (grp) { grp.items.forEach(function (it) { out.push(Object.assign({ _group: grp.name }, it)); }); });
    return out;
  }
  // Every approved photo, flattened into a memory wall (each photo carries its sender).
  function photoWall(doc) {
    var subs = approvedSubs(doc).map(function (s) { return hydrate(doc, s); });
    var wall = [];
    subs.forEach(function (s) {
      (s.media || []).forEach(function (m) {
        if (m.kind === "photo") wall.push({ url: m.url, caption: m.caption || "", from: s.name, relationship: s.relationship || "", subId: s.id });
      });
    });
    return wall;
  }
  // Songs are submissions of type "song"; text = "Title — Artist" with an optional link line.
  function parseSong(text){
    var lines = String(text || "").split(/\n/).map(function(l){ return l.trim(); }).filter(Boolean);
    var link = "", info = [];
    lines.forEach(function(l){ if (!link && /^https?:\/\//i.test(l)) link = l; else info.push(l); });
    var first = info[0] || "", parts = first.split(/\s+[—-]\s+/);
    return { title: (parts[0] || first).trim(), artist: (parts.slice(1).join(" - ") || "").trim(), link: link };
  }
  function songsList(doc){
    return approvedSubs(doc).filter(function(s){ return s.type === "song"; }).map(function(s){
      var p = parseSong(s.text);
      return { id: s.id, from: s.name, relationship: s.relationship || "", title: p.title, artist: p.artist, link: p.link };
    });
  }

  // "This Is Your Life" timeline entries, oldest year first (blank/invalid years sort last).
  function sortMilestones(list){
    return (list || []).slice().sort(function(a,b){
      var ya = parseInt(a && a.year, 10), yb = parseInt(b && b.year, 10);
      if (isNaN(ya) && isNaN(yb)) return 0; if (isNaN(ya)) return 1; if (isNaN(yb)) return -1;
      return ya - yb;
    });
  }

  // Reorganize the flat message list into the AI Story Director's chapters (title + narrator intro +
  // ordered messages). Unknown ids are ignored; any un-chaptered messages become a final chapter.
  function storyGroups(story, messages){
    if (!story || !Array.isArray(story.chapters)) return null;
    var byId = {}; (messages || []).forEach(function(m){ byId[m.id] = m; });
    var used = {}, groups = [];
    story.chapters.forEach(function(ch){
      var items = (ch.ids || []).map(function(id){ return byId[id]; }).filter(Boolean);
      items.forEach(function(m){ used[m.id] = true; });
      if (items.length) groups.push({ name: ch.title || "", intro: ch.intro || "", items: items });
    });
    if (!groups.length) return null;   // AI returned no usable chapters -> fall back to default groups
    var leftover = (messages || []).filter(function(m){ return !used[m.id]; });
    if (leftover.length) groups.push({ name: "And so many more", intro: "", items: leftover });
    return groups;
  }

  function statsOf(doc) {
    var all = Object.keys(doc.submissions).map(function (k) { return doc.submissions[k]; });
    var byStatus = { pending: 0, approved: 0, rejected: 0 };
    var byType = { video: 0, written: 0, voice: 0, photo: 0 };
    var photos = 0;
    all.forEach(function (s) {
      if (byStatus[s.status] != null) byStatus[s.status]++;
      if (byType[s.type] != null) byType[s.type]++;
      if (s.type === "photo") photos += (s.mediaIds || []).length;
    });
    return { total: all.length, byStatus: byStatus, byType: byType, photos: photos };
  }

  // The public reveal model — only approved content, only when published & token matches.
  function buildReveal(doc) {
    var c = doc.config;
    return {
      config: {
        honoreeName: c.honoreeName, displayName: c.displayName || c.honoreeName, age: c.age,
        occasion: c.occasion || "birthday",
        occasionTitle: c.occasionTitle, headerPhotoUrl: c.headerPhotoUrl, eventDate: c.eventDate,
        honoreeReply: c.honoreeReply || null,
        musicUrl: c.musicUrl || "",
        milestones: sortMilestones(c.milestones || []),
        narration: c.narration || "",
        aiEnabled: !!c.aiEnabled,
        story: c.story || null,
        essay: c.essay || "",
        reaction: c.reaction || null,
        animations: c.animations || {},
        trailer: c.trailer || null,         // the movie-trailer cut (config.trailer)
      },
      groups: groupApproved(doc),
      messages: revealMessages(doc),
      photoWall: photoWall(doc),
      songs: songsList(doc),
      stats: statsOf(doc),
    };
  }
  function publicLanding(doc) {
    var c = doc.config;
    return {
      honoreeName: c.honoreeName, displayName: c.displayName || c.honoreeName, age: c.age,
      occasion: c.occasion || "birthday",
      introText: c.introText, eventDate: c.eventDate, submitClosed: !!c.submitClosed,
      thankYouText: c.thankYouText, published: !!c.published,
    };
  }

  // ==================================================================
  //  STORAGE — two modes behind one interface.
  //  MOCK: localStorage (falls back to in-memory when it overflows or is absent).
  //  SUPABASE: real Auth + Postgres + Storage (only when configured & lib present).
  // ==================================================================
  // Multi-page: every db call targets the CURRENT page (set from the URL by the router).
  // The founding page keeps the legacy storage keys so existing data/tests are untouched.
  var DEFAULT_SLUG = "jtruchelsr";
  var PAGE = { slug: DEFAULT_SLUG };
  var _mem = { docs: {}, sess: {}, over: false, pagesIdx: null };
  function _hasLS() { try { return typeof localStorage !== "undefined" && !!localStorage; } catch (e) { return false; } }
  function _docKey() { return PAGE.slug === DEFAULT_SLUG ? "bd_tribute_doc" : "bd_page_" + PAGE.slug; }
  function _sessKey() { return PAGE.slug === DEFAULT_SLUG ? "bd_admin_session" : "bd_admin_session_" + PAGE.slug; }
  // Mock page registry: which slugs exist (the founding page always does).
  function _pagesIdx() {
    if (_hasLS()) { try { return JSON.parse(localStorage.getItem("bd_pages_idx") || "{}"); } catch (e) {} }
    return _mem.pagesIdx || {};
  }
  function _pagesIdxSave(x) {
    _mem.pagesIdx = x;
    if (_hasLS()) { try { localStorage.setItem("bd_pages_idx", JSON.stringify(x)); } catch (e) {} }
  }
  function _pageExists(slug) { return slug === DEFAULT_SLUG || !!_pagesIdx()[slug]; }

  // ---- Supabase wiring (fill these to go live; anon key is public-by-design, RLS protects data) ----
  var SUPABASE_URL = "https://chfqgpaajvddljwnpcwd.supabase.co";  // e.g. "https://xxxx.supabase.co"
  var SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNoZnFncGFhanZkZGxqd25wY3dkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQwMzMyOTIsImV4cCI6MjA5OTYwOTI5Mn0.up8F7XSBMf3qlK-igSIdPv2gGNr4IJwVHh1VCzzT4pY"; // e.g. "eyJhbGciOi..."
  var sb = null, _sbUser = null, _cache = null, _recovery = false, _recoveryCbs = [];
  if (typeof window !== "undefined" && typeof supabase !== "undefined" && SUPABASE_URL.indexOf("http") === 0) {
    try { sb = supabase.createClient(SUPABASE_URL, SUPABASE_ANON); } catch (e) { sb = null; }
  }
  function sbActive() { return !!sb; }

  // ---- mock doc load/save (keyed by the current page's slug) ----
  function _rawLoad() {
    var k = _docKey();
    if (_hasLS()) { var r = localStorage.getItem(k); if (r) { try { return JSON.parse(r); } catch (e) {} } }
    if (_mem.docs[k]) { try { return JSON.parse(_mem.docs[k]); } catch (e) {} }
    return null;
  }
  function _rawSave(d) {
    var k = _docKey(), s = JSON.stringify(d);
    _mem.docs[k] = s; // always keep the in-memory copy (survives quota failures within a session)
    if (_hasLS()) {
      try { localStorage.setItem(k, s); _mem.over = false; }
      catch (e) { _mem.over = true; /* quota: large media won't persist across reloads in mock mode */ }
    }
  }
  // Load the doc, filling defaults and minting a reveal token exactly once.
  function _load() {
    var d = _rawLoad();
    if (!d) d = blank();
    if (!d.config) d.config = defaultConfig();
    else d.config = Object.assign(defaultConfig(), d.config);
    d.submissions = d.submissions || {}; d.media = d.media || {}; d.meta = d.meta || {};
    if (!d.config.revealToken) d.config.revealToken = token();
    return d;
  }
  function _persist(d) { _rawSave(d); return d; }
  function _ensureDoc() { var d = _load(); if (!_rawLoad()) _persist(d); else if (!(_rawLoad().config || {}).revealToken) _persist(d); return d; }

  // ---- mock admin session (per page) ----
  function _getSess() { if (_hasLS()) return localStorage.getItem(_sessKey()); return _mem.sess[_sessKey()]; }
  function _setSess(v) { if (_hasLS()) { if (v) localStorage.setItem(_sessKey(), v); else localStorage.removeItem(_sessKey()); } else _mem.sess[_sessKey()] = v || null; }

  function reject(m) { return Promise.reject(new Error(m)); }
  function resolve(v) { return Promise.resolve(v); }
  function _requireAdmin() { if (sbActive()) { if (!_sbUser) return false; return true; } return !!_getSess(); }

  // Call a page-scoped RPC; on a v1 backend (which doesn't know p_slug yet) fall back to the
  // legacy argument shape — but ONLY for the founding page, so the client can deploy before
  // the schema-v2 migration runs without any risk to the live tribute.
  function rpcPage(name, args, legacyArgs) {
    return sb.rpc(name, args).then(function (r) {
      if (r.error) {
        var msg = r.error.message || "";
        if (legacyArgs !== undefined && PAGE.slug === DEFAULT_SLUG && /schema cache|does not exist|p_slug/i.test(msg)) {
          return sb.rpc(name, legacyArgs).then(function (r2) { if (r2.error) throw new Error(r2.error.message); return r2.data; });
        }
        throw new Error(msg);
      }
      return r.data;
    });
  }

  // ------------------------------------------------------------------
  //  db seam — every method async & Supabase-shaped.
  // ------------------------------------------------------------------
  // The mock's short-link index: localStorage when there is one, else memory (the Node tests).
  var _shortMem = null;
  function _shortIdx(){ if (_shortMem) return _shortMem; var idx = {}; try { idx = JSON.parse(localStorage.getItem("bd_short_idx") || "{}"); } catch (e) {} _shortMem = idx; return idx; }
  function _shortIdxSave(idx){ _shortMem = idx; try { localStorage.setItem("bd_short_idx", JSON.stringify(idx)); } catch (e) {} }

  var db = {
    mode: function () { return sbActive() ? "supabase" : "mock"; },
    storageWarning: function () { return _mem.over; },

    // ---------- init ----------
    init: function () {
      if (!sbActive()) { _ensureDoc(); return resolve(); }
      return sb.auth.getSession().then(function (s) {
        _sbUser = (s.data && s.data.session && s.data.session.user) || null;
        sb.auth.onAuthStateChange(function (_e, session) {
          _sbUser = session ? session.user : null;
          if (_e === "PASSWORD_RECOVERY") {   // arrived via a reset-email link
            _recovery = true;
            try { if (window.location.hash.indexOf("admin") < 0) window.location.hash = "#admin"; } catch (e) {}
            _recoveryCbs.forEach(function (cb) { try { cb(); } catch (e) {} });
          }
        });
      }).catch(function () {});
    },
    // ---------- password reset (Supabase mode) ----------
    // Co-admins: the owner adds people by email; each gets the whole dashboard for this page.
    // Mock keeps a plain list in config.coAdmins (no accounts in mock mode).
    listPageAdmins: function () {
      if (!_requireAdmin()) return reject("unauthorized");
      if (sbActive()) return sb.rpc("page_admins", { p_slug: PAGE.slug }).then(function (r) { if (r.error) throw new Error(r.error.message); return r.data; });
      var d = _ensureDoc(); return resolve({ owner: "organizer (mock)", you: "organizer (mock)", youAreOwner: true, members: (d.config.coAdmins || []).map(function (e) { return { email: e, joined: false, role: "admin" }; }) });
    },
    addPageAdmin: function (email) {
      if (!_requireAdmin()) return reject("unauthorized");
      var e = String(email || "").trim().toLowerCase();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e)) return reject("That does not look like an email address.");
      if (sbActive()) return sb.rpc("add_page_admin", { p_email: e, p_slug: PAGE.slug }).then(function (r) { if (r.error) throw new Error(r.error.message); return r.data; });
      var d = _ensureDoc(); var list = (d.config.coAdmins || []).slice(); if (list.indexOf(e) < 0) list.push(e); if (list.length > 10) return reject("A page can have up to 10 co-admins."); d.config.coAdmins = list; _persist(d);
      return db.listPageAdmins();
    },
    removePageAdmin: function (email) {
      if (!_requireAdmin()) return reject("unauthorized");
      var e = String(email || "").trim().toLowerCase();
      if (sbActive()) return sb.rpc("remove_page_admin", { p_email: e, p_slug: PAGE.slug }).then(function (r) { if (r.error) throw new Error(r.error.message); return r.data; });
      var d = _ensureDoc(); d.config.coAdmins = (d.config.coAdmins || []).filter(function (x) { return x !== e; }); _persist(d);
      return db.listPageAdmins();
    },
    // A co-admin's first visit: create the account for the email the owner added.
    adminSignUp: function (email, password) {
      if (!sbActive()) return reject("Accounts need the live backend.");
      return sb.auth.signUp({ email: String(email || "").trim(), password: password }).then(function (r) {
        if (r.error) throw new Error(r.error.message);
        if (r.data.session) { _sbUser = r.data.user; return { email: r.data.user.email, signedIn: true }; }
        return { email: String(email || "").trim(), signedIn: false };   // email confirmation is on: they confirm, then sign in
      });
    },
    resetPassword: function (email) {
      if (!sbActive()) return reject("Reset emails need the live backend.");
      var back = window.location.origin + "/" + PAGE.slug;   // no hash — supabase appends its own
      return sb.auth.resetPasswordForEmail(String(email || "").trim(), { redirectTo: back })
        .then(function (r) { if (r.error) throw new Error(r.error.message); return true; });
    },
    passwordRecovery: function () { return _recovery; },
    watchRecovery: function (cb) { _recoveryCbs.push(cb); if (_recovery) { try { cb(); } catch (e) {} } },
    updatePassword: function (pw) {
      if (!sbActive()) return reject("unavailable in mock mode");
      return sb.auth.updateUser({ password: pw }).then(function (r) {
        if (r.error) throw new Error(r.error.message);
        _recovery = false; _sbUser = r.data.user || _sbUser; return true;
      });
    },

    // ---------- admin auth ----------
    // Mock: password compared to config.adminPassword. Supabase: real email/password Auth.
    adminSignIn: function (email, password) {
      if (sbActive()) {
        return sb.auth.signInWithPassword({ email: email, password: password }).then(function (r) {
          if (r.error) throw new Error(r.error.message); _sbUser = r.data.user; return { email: r.data.user.email };
        });
      }
      var d = _ensureDoc();
      var pass = password == null ? email : password; // mock lets you sign in with just a password
      if (pass === d.config.adminPassword) { _setSess("admin_" + hash(pass)); return resolve({ email: "admin" }); }
      return reject("That password doesn't match.");
    },
    adminSignOut: function () {
      if (sbActive()) return sb.auth.signOut().then(function () { _sbUser = null; });
      _setSess(null); return resolve();
    },
    currentAdmin: function () {
      if (sbActive()) return resolve(_sbUser ? { email: _sbUser.email } : null);
      return resolve(_getSess() ? { email: "admin" } : null);
    },
    isAdmin: function () { return _requireAdmin(); },

    // ---------- page context (multi-page) ----------
    setPage: function (slug) { PAGE.slug = String(slug || DEFAULT_SLUG).toLowerCase(); },
    currentSlug: function () { return PAGE.slug; },
    defaultSlug: function () { return DEFAULT_SLUG; },
    checkSlug: function (slug) {
      var v = validateSlug(slug); if (!v.ok) return resolve({ available: false, reason: v.error });
      if (sbActive()) return sb.rpc("slug_available", { p_slug: slug })
        .then(function (r) { if (r.error) throw new Error(r.error.message); return { available: !!r.data }; })
        .catch(function () { return { available: true, unchecked: true }; });   // v1 backend can't check yet
      return resolve({ available: !_pageExists(slug) });
    },
    // Create a brand-new page: template = config patch from occasionTemplate().
    // Supabase: signs the organizer up (or in) first, then the create_page RPC (beta-code gated).
    createPage: function (opts) {
      var slug = String(opts.slug || "").toLowerCase();
      var v = validateSlug(slug); if (!v.ok) return reject(v.error);
      var data = Object.assign({}, opts.template || {});
      if (sbActive()) {
        var doCreate = function () {
          return sb.rpc("create_page", { p_slug: slug, p_data: data, p_code: String(opts.betaCode || "") })
            .then(function (r) { if (r.error) throw new Error(r.error.message); return { slug: slug, created: true }; });
        };
        if (_sbUser) return doCreate();
        return sb.auth.signUp({ email: opts.email, password: opts.password }).then(function (r) {
          if (r.error) {
            if (/already (been )?registered/i.test(r.error.message)) {
              return sb.auth.signInWithPassword({ email: opts.email, password: opts.password }).then(function (r2) {
                if (r2.error) throw new Error("That email already has an account, but the password didn't match it. Use the same password you signed up with.");
                _sbUser = r2.data.user;
              });
            }
            throw new Error(r.error.message);
          }
          if (r.data && r.data.session) { _sbUser = r.data.user; return; }
          var e = new Error("confirm-email"); e.code = "confirm-email"; throw e;   // confirmations are on
        }).then(doCreate);
      }
      if (_pageExists(slug)) return reject("That address is taken — try another.");
      var prev = PAGE.slug; PAGE.slug = slug;
      try {
        var d = blank();
        d.config = Object.assign(defaultConfig(), data);
        if (opts.password) d.config.adminPassword = opts.password;
        d.config.revealToken = token();
        _persist(d);
        var idx = _pagesIdx(); idx[slug] = { slug: slug, at: now() }; _pagesIdxSave(idx);
        _setSess("admin_" + hash(d.config.adminPassword));
      } finally { PAGE.slug = prev; }
      return resolve({ slug: slug, created: true });
    },

    // ---------- config ----------
    // ---- short links (keepsakepage.com/<word>, optional viewer password) ----
    setShortLink: function (word, pass, kind) {
      if (!_requireAdmin()) return reject("unauthorized");
      kind = kind === "trailer" ? "trailer" : "reveal"; var f = linkFields(kind);
      var v = validateShortWord(word); if (!v.ok) return reject(v.error);
      if (sbActive()) return sb.rpc("set_short_link", { p_word: v.word, p_pass: pass || "", p_slug: PAGE.slug, p_kind: kind }).then(function (r) { if (r.error) throw new Error(r.error.message); return r.data; });
      var idx = _shortIdx();
      Object.keys(idx).forEach(function (k) { if (idx[k].slug === PAGE.slug && (idx[k].kind || "reveal") === kind) delete idx[k]; });
      var d = _ensureDoc();
      if (v.word) {
        if (idx[v.word] || _pageExists(v.word)) return reject("That word is taken - try another.");
        idx[v.word] = { slug: PAGE.slug, pass: pass || "", kind: kind };
        d.config[f.word] = v.word; if (pass) d.config[f.pass] = "mock"; else delete d.config[f.pass];
      } else { delete d.config[f.word]; delete d.config[f.pass]; }
      _shortIdxSave(idx);
      _persist(d); return resolve(clone(d.config));
    },
    shortInfo: function (word) {
      if (sbActive()) return sb.rpc("short_info", { p_word: word }).then(function (r) { if (r.error) throw new Error(r.error.message); return r.data; });
      var idx = _shortIdx();
      var e = idx[String(word || "").toLowerCase()]; if (!e) return reject("not found");
      return resolve({ slug: e.slug, protected: !!e.pass, kind: e.kind || "reveal" });
    },
    openShort: function (word, pass) {
      if (sbActive()) return sb.rpc("open_short", { p_word: word, p_pass: pass || "" }).then(function (r) { if (r.error) throw new Error(r.error.message); return r.data; });
      var idx = _shortIdx();
      var e = idx[String(word || "").toLowerCase()]; if (!e) return reject("not found");
      if (e.pass && e.pass !== String(pass || "").trim()) return reject("wrong password");
      var saved = PAGE.slug; PAGE.slug = e.slug; var tok = (_ensureDoc().config || {}).revealToken; PAGE.slug = saved;
      return resolve({ slug: e.slug, token: tok, kind: e.kind || "reveal" });
    },
    getLanding: function () {
      if (sbActive()) return rpcPage("get_landing", { p_slug: PAGE.slug }, {});
      if (!_pageExists(PAGE.slug)) return reject("not found");
      return resolve(publicLanding(_ensureDoc()));
    },
    getConfig: function () {
      if (!_requireAdmin()) return reject("unauthorized");
      if (sbActive()) return sb.from("pages").select("data").eq("slug", PAGE.slug).single()
        .then(function (r) { if (r.error || !r.data) throw new Error(r.error ? r.error.message : "no page"); return r.data.data; })
        .catch(function (e) {
          if (PAGE.slug !== DEFAULT_SLUG) throw e;   // only the founding page has a legacy config row
          return sb.from("config").select("*").limit(1).single().then(function (r) { if (r.error) throw new Error(r.error.message); return r.data.data || r.data; });
        });
      return resolve(clone(_ensureDoc().config));
    },
    updateConfig: function (patch) {
      if (!_requireAdmin()) return reject("unauthorized");
      if (sbActive()) return rpcPage("admin_update_config", { patch: patch, p_slug: PAGE.slug }, { patch: patch });
      var d = _ensureDoc(); d.config = Object.assign({}, d.config, patch); _persist(d); return resolve(clone(d.config));
    },

    // ---------- media upload (turns a Blob/File into a storable ref) ----------
    // Returns { url, kind }. Mock stores a data-URI; Supabase uploads to a Storage bucket.
    uploadMedia: function (blob, kind, filename) {
      if (sbActive()) {
        // Retry once with a fresh path — covers transient network drops on flaky phone data.
        var mk = function () {
          var path = kind + "/" + uid() + "_" + (filename || "file").replace(/[^\w.\-]/g, "_");
          return sb.storage.from("tribute-media").upload(path, blob, { contentType: blob.type || undefined, upsert: false })
            .then(function (r) { if (r.error) throw new Error(r.error.message); var pu = sb.storage.from("tribute-media").getPublicUrl(path); return { url: pu.data.publicUrl, kind: kind, path: path }; });
        };
        return mk().catch(function () { return mk(); });
      }
      return new Promise(function (res, rej) {
        var fr = new FileReader();
        // MediaRecorder blobs report e.g. "video/webm;codecs=vp8,opus" -- the comma inside a
        // data: URI's media type breaks Chrome's demuxer, so keep just the base MIME type.
        fr.onload = function () { res({ url: String(fr.result).replace(/^(data:[^;,]+);codecs=[^;]+/i, "$1"), kind: kind }); };
        fr.onerror = function () { rej(new Error("Could not read the file.")); };
        fr.readAsDataURL(blob);
      });
    },

    // ---------- AI (Claude via the ai-assist Edge Function; see supabase/AI-FEATURES.md) ----------
    aiAssist: function (action, payload) {
      if (sbActive()) {
        return sb.functions.invoke("ai-assist", { body: Object.assign({ action: action }, payload || {}) })
          .then(function (r) { if (r.error) throw new Error(r.error.message || "AI request failed"); if (r.data && r.data.error) throw new Error(r.data.error); return r.data || {}; });
      }
      // mock canned responses so the admin UI is testable offline
      if (action === "narrate") return resolve({ text: "Eighty years ago, the world got a little brighter. Through every season since — the laughter, the lessons, the quiet acts of love — one thing has never changed: how deeply you are loved. Today, everyone lucky enough to know you has gathered to say so. Here they are." });
      if (action === "translate") return resolve({ text: "(translated) " + String((payload && payload.text) || "") });
      if (action === "essay") return resolve({ text: "Ask anyone about him and the same portrait emerges — a man of quiet strength and easy laughter. The grandkids remember the fishing trips and the stories; old friends, six decades of loyalty; the neighbors, a kindness that never asked for thanks. Across every message runs the same thread: he made people feel loved. That, more than any milestone, is the measure of these eighty years." });
      if (action === "direct") { var msgs = (payload && payload.messages) || [];
        var half = Math.ceil(msgs.length / 2);
        return resolve({ story: {
          opening: "Some lives are measured in years. His is measured in the people who love him. Here is their story of him.",
          closing: "Eighty years, and every one of them left a mark on someone. Happy birthday — from all of us.",
          chapters: [
            { title: "The Heart of the Family", intro: "To those closest to him, he was home.", ids: msgs.slice(0, half).map(function(m){ return m.id; }) },
            { title: "A Friend to Everyone", intro: "Beyond the family, a wider circle of love.", ids: msgs.slice(half).map(function(m){ return m.id; }) },
          ],
        } });
      }
      if (action === "caption") return resolve({ text: "A cherished moment, full of warmth." });
      if (action === "transcribe") return resolve(payload && payload.segments
        ? { text: "Hi John, happy birthday. I still remember the summer you taught us all to sail. Love you.",
            segments: [{ start: 0, end: 1.6, text: "Hi John, happy birthday." }, { start: 1.6, end: 2.6, text: "I still remember the summer you taught us all to sail." }, { start: 2.6, end: 3.0, text: "Love you." }] }
        : { text: "(transcript) A heartfelt spoken message." });
      if (action === "cut") { var its = (payload && payload.items) || []; var cut = { clips: [], quotes: {}, order: [], drop: [] };
        its.forEach(function(it){ if (it.kind === "video" || it.kind === "voice") { var sg = (it.segments || [])[1] || (it.segments || [])[0] || [0, 4, ""]; cut.clips.push({ id: it.id, start: sg[0], end: sg[1], why: "the specific memory" }); }
          if (it.kind === "note") cut.quotes[it.sub || it.id] = String(it.text || "").split(/[.!?]/)[0].trim(); });
        cut.order = its.map(function(it){ return it.id; }).reverse();
        return resolve({ cut: cut }); }
      return reject("unknown action");
    },

    // ---------- guest submission (public insert) ----------
    // payload = { guest:{name,relationship,email}, items:[{type,text?,media:[{kind,url,caption,filename,size}]}] }
    submit: function (payload) {
      var g = (payload && payload.guest) || {}, items = (payload && payload.items) || [];
      var vg = validateGuest(g); if (!vg.ok) return reject(vg.errors[0]);
      if (!items.length) return reject("Add at least one message or photo.");
      for (var i = 0; i < items.length; i++) { var vi = validateItem(items[i]); if (!vi.ok) return reject(vi.errors[0]); }

      if (sbActive()) {
        // security-definer RPC: inserts the submission + its media atomically as pending.
        var subArgs = { p_name: g.name, p_relationship: g.relationship || null, p_email: g.email || null, p_items: items, p_promo: !!g.promo };
        return rpcPage("submit_tribute", Object.assign({ p_slug: PAGE.slug }, subArgs), subArgs)
          .then(function () { return { count: items.length }; });
      }
      var d = _ensureDoc();
      items.forEach(function (item) {
        var sid = uid(), mediaIds = [];
        (item.media || []).forEach(function (m) {
          var mid = uid();
          d.media[mid] = { id: mid, submissionId: sid, kind: m.kind, url: m.url, caption: m.caption || "", filename: m.filename || "", size: m.size || 0, createdAt: now() };
          mediaIds.push(mid);
        });
        d.submissions[sid] = {
          id: sid, name: String(g.name).trim(), relationship: (g.relationship || "").trim(), email: (g.email || "").trim(), promo: !!g.promo,
          type: item.type, text: (item.type === "written" || item.type === "song") ? String(item.text || "").trim() : "",
          mediaIds: mediaIds, status: "pending", featured: false, group: "", order: null,
          createdAt: now(), updatedAt: now(),
        };
      });
      _persist(d); return resolve({ count: items.length });
    },
    // Fire-and-forget "we got it" email to the contributor (Supabase mode only). Since 2026-10-11 the
    // function takes only the edit token and derives the address, names and links from the rows
    // it proves ownership of (audit finding C); without a token there is nothing to send.
    sendReceipt: function (info) {
      if (!sbActive() || !(info && info.editToken)) return resolve();
      try {
        return sb.functions.invoke("notify-submission", { body: { receipt: true, editToken: String(info.editToken) } }).catch(function () {});
      } catch (e) { return resolve(); }
    },
    // ---------- photo animation (Replicate via the animate-photo function) ----------
    // Two steps because a render takes 30s-3min: start, then poll. The function copies the
    // finished clip into our own storage, so the URL it returns is permanent.
    // 2026-10-11: the function resolves the photo from the page's media row (never a URL) and needs
    // the page slug + the organizer's session (audit finding A).
    animateStart: function (mediaId, slug) {
      if (!sbActive()) return reject("Animation needs the live backend.");
      return sb.functions.invoke("animate-photo", { body: { action: "start", mediaId: mediaId, slug: slug || PAGE.slug } })
        .then(function (r) {
          if (r.error) throw new Error(r.error.message || "Could not start the animation");
          if (r.data && r.data.error) throw new Error(r.data.error);
          return r.data;
        });
    },
    animateStatus: function (id, slug) {
      if (!sbActive()) return reject("Animation needs the live backend.");
      return sb.functions.invoke("animate-photo", { body: { action: "status", id: id, slug: slug || PAGE.slug } })
        .then(function (r) {
          if (r.error) throw new Error(r.error.message || "Could not check progress");
          if (r.data && r.data.error && !r.data.status) throw new Error(r.data.error);
          return r.data;
        });
    },

    // Organizer alert ("someone just submitted"): retired 2026-10-11 (audit finding C). The
    // database's submissions_enqueue_notify trigger -> page-lifecycle contribution.new emails the
    // organizers for every new contribution, so nothing is callable from here any more.
    notifyOrganizer: function () { return resolve(); },

    // ---------- admin: review ----------
    listSubmissions: function () {
      if (!_requireAdmin()) return reject("unauthorized");
      if (sbActive()) return rpcPage("admin_list_submissions", { p_slug: PAGE.slug }, {}).then(function (d) { return d || []; });
      var d = _ensureDoc();
      var list = Object.keys(d.submissions).map(function (k) { return hydrate(d, d.submissions[k]); })
        .sort(function (a, b) { return (b.createdAt || 0) - (a.createdAt || 0); });
      return resolve(clone(list));
    },
    // Full backup: every submission (hydrated with media URLs) + the config. Admin-only.
    exportAll: function () {
      if (!_requireAdmin()) return reject("unauthorized");
      if (sbActive()) return Promise.all([db.listSubmissions(), db.getConfig()]).then(function (r) { return { submissions: r[0], config: r[1] }; });
      var d = _ensureDoc();
      var subs = Object.keys(d.submissions).map(function (k) { return hydrate(d, d.submissions[k]); })
        .sort(function (a, b) { return (a.createdAt || 0) - (b.createdAt || 0); });
      return resolve(clone({ submissions: subs, config: d.config }));
    },
    updateSubmission: function (id, patch) {
      if (!_requireAdmin()) return reject("unauthorized");
      if (sbActive()) return sb.rpc("admin_update_submission", { p_id: id, patch: patch }).then(function (r) { if (r.error) throw new Error(r.error.message); return r.data; });
      var d = _ensureDoc(), s = d.submissions[id]; if (!s) return reject("not found");
      var allowed = ["status", "text", "featured", "group", "order", "relationship", "name"];
      allowed.forEach(function (k) { if (patch[k] !== undefined) s[k] = patch[k]; });
      if (patch.captions) { (s.mediaIds || []).forEach(function (mid) { if (patch.captions[mid] !== undefined && d.media[mid]) d.media[mid].caption = patch.captions[mid]; }); }
      s.updatedAt = now(); _persist(d); return resolve(hydrate(d, s));
    },
    setStatus: function (id, status) { return db.updateSubmission(id, { status: status }); },
    bulkStatus: function (ids, status) {
      if (!_requireAdmin()) return reject("unauthorized");
      if (!canTransition("pending", status)) return reject("bad status");
      if (sbActive()) return sb.rpc("admin_bulk_status", { p_ids: ids, p_status: status }).then(function (r) { if (r.error) throw new Error(r.error.message); return r.data; });
      var d = _ensureDoc(); (ids || []).forEach(function (id) { if (d.submissions[id]) { d.submissions[id].status = status; d.submissions[id].updatedAt = now(); } });
      _persist(d); return resolve({ count: (ids || []).length });
    },
    deleteSubmission: function (id) {
      if (!_requireAdmin()) return reject("unauthorized");
      if (sbActive()) return sb.rpc("admin_delete_submission", { p_id: id }).then(function (r) { if (r.error) throw new Error(r.error.message); return r.data; });
      var d = _ensureDoc(), s = d.submissions[id]; if (!s) return resolve();
      (s.mediaIds || []).forEach(function (mid) { delete d.media[mid]; }); delete d.submissions[id]; _persist(d); return resolve();
    },

    // ---------- publish / reveal ----------
    getRevealAdmin: function () { // admin preview of the reveal (regardless of publish flag)
      if (!_requireAdmin()) return reject("unauthorized");
      if (sbActive()) return rpcPage("admin_reveal_preview", { p_slug: PAGE.slug }, {});
      return resolve(buildReveal(_ensureDoc()));
    },
    // PUBLIC reveal read — gated on published + matching token. This is the only public read of content.
    getReveal: function (revealToken) {
      if (sbActive()) return sb.rpc("get_reveal", { p_token: revealToken }).then(function (r) { if (r.error) throw new Error(r.error.message); return r.data; });
      var d = _ensureDoc();
      if (!d.config.published) return reject("not published");
      if (revealToken !== d.config.revealToken) return reject("bad token");
      if (d.config.revealAt) { var _t = Date.parse(d.config.revealAt);
        if (!isNaN(_t) && now() < _t) return resolve({ scheduled: true, revealAt: d.config.revealAt,
          config: { honoreeName: d.config.honoreeName, displayName: d.config.displayName || d.config.honoreeName, age: d.config.age, occasion: d.config.occasion || "birthday" } }); }
      return resolve(buildReveal(d));
    },

    // ---------- test/dev helpers (mock only) ----------
    _resetMem: function () { _mem = { docs: {}, sess: {}, over: false, pagesIdx: null }; if (_hasLS()) { try { localStorage.removeItem(_docKey()); localStorage.removeItem(_sessKey()); } catch (e) {} } },
    _doc: function () { return _ensureDoc(); },
    _seedDemo: function () {
      var d = blank(); d.config = Object.assign(defaultConfig(), {
        honoreeName: "Dad", displayName: "Robert", occasionTitle: "80 Years of Robert",
        groups: ["From the grandkids", "College friends", "The neighbors"],
        revealToken: token(),
      });
      function px(hex) { return "data:image/svg+xml;utf8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300"><rect width="400" height="300" fill="' + hex + '"/><text x="200" y="160" font-size="120" text-anchor="middle" fill="rgba(255,255,255,.5)">📷</text></svg>'); }
      var demo = [
        { name: "Emma", relationship: "granddaughter", type: "written", text: "Grandpa, you taught me to fish and to tell a good story. Happy 80th — you're the best!", status: "approved", group: "From the grandkids", featured: true },
        { name: "Jack", relationship: "grandson", type: "written", text: "80 trips around the sun and you still beat me at chess every time. Love you Grandpa.", status: "approved", group: "From the grandkids" },
        { name: "Bill", relationship: "college roommate", type: "written", text: "From dorm-room disasters to 60 years of friendship. Here's to you, old friend.", status: "approved", group: "College friends" },
        { name: "The Hendersons", relationship: "next door", type: "photo", status: "approved", group: "The neighbors", photos: [px("#8A3B54"), px("#C99A3A")] },
        { name: "Susan", relationship: "daughter", type: "photo", status: "pending", photos: [px("#6B8E5A")] },
        { name: "Old coworker", relationship: "", type: "written", text: "spam-ish test note", status: "rejected" },
      ];
      demo.forEach(function (x, i) {
        var sid = uid(), mediaIds = [];
        (x.photos || []).forEach(function (p) { var mid = uid(); d.media[mid] = { id: mid, submissionId: sid, kind: "photo", url: p, caption: "", createdAt: now() + i }; mediaIds.push(mid); });
        d.submissions[sid] = { id: sid, name: x.name, relationship: x.relationship, email: "", type: x.type, text: x.text || "", mediaIds: mediaIds, status: x.status, featured: !!x.featured, group: x.group || "", order: i, createdAt: now() - (10 - i) * 1000, updatedAt: now() };
      });
      _persist(d); return d.config.revealToken;
    },
  };

  // -------------------- occasion presets (multi-occasion theming) --------------------
  function ordinal(n){ n = Number(n) || 0; var s = ["th","st","nd","rd"], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
  var OCCASIONS = {
    // Each preset drives theme + copy everywhere: kicker/reveal/tab (headlines), fin (ceremony
    // finale line), foot (reveal footer line), noun (the "…keepsake" phrase used in invites).
    birthday: { label: "Birthday", emoji: "🎂", heroEmoji: ["🎈","🎂","🎉"], festive: true, showNumber: true, mood: "joyful",
      kicker: function(a){ return a ? ("✨ A surprise " + ordinal(a) + " birthday celebration ✨") : "✨ A birthday celebration ✨"; },
      reveal: function(n, a){ return a ? (a + " Years of " + n) : ("Celebrating " + n); },
      tab: function(n, a){ return "🎉 " + String(n).split(" ")[0] + "'s " + (a ? ordinal(a) : "birthday"); },
      fin: function(f, a){ return "Happy " + (a ? ordinal(a) + " " : "") + "Birthday, " + f + "!"; },
      foot: function(n, a){ return "Happy " + (a ? ordinal(a) + " " : "") + "Birthday, " + n + " — with love from all of us."; },
      noun: function(a){ return (a ? ordinal(a) + " " : "") + "birthday keepsake"; } },
    retirement: { label: "Retirement", emoji: "🥂", heroEmoji: ["🎉","🥂","👏"], festive: true, showNumber: false, mood: "warm",
      kicker: function(){ return "✨ Celebrating a wonderful career ✨"; },
      reveal: function(n){ return "Celebrating " + n; },
      tab: function(n){ return "🎉 " + String(n).split(" ")[0] + "'s retirement"; },
      fin: function(f){ return "Happy retirement, " + f + "!"; },
      foot: function(n){ return "Happy retirement, " + n + " — with love from all of us."; },
      noun: function(){ return "retirement keepsake"; } },
    anniversary: { label: "Anniversary", emoji: "💍", heroEmoji: ["💐","💍","🥂"], festive: true, showNumber: true, mood: "tender",
      kicker: function(a){ return a ? ("✨ Celebrating " + a + " years of love ✨") : "✨ Celebrating a life of love ✨"; },
      reveal: function(n, a){ return a ? (a + " Years Together") : ("Celebrating " + n); },
      tab: function(n){ return "💍 " + n + "'s anniversary"; },
      fin: function(f, a){ return "Happy " + (a ? ordinal(a) + " " : "") + "Anniversary!"; },
      foot: function(n, a){ return "Happy anniversary, " + n + " — with love from all of us."; },
      noun: function(){ return "anniversary keepsake"; } },
    graduation: { label: "Graduation", emoji: "🎓", heroEmoji: ["🎓","🎉","🌟"], festive: true, showNumber: false, mood: "joyful",
      kicker: function(){ return "✨ The tassel is turned ✨"; },
      reveal: function(n){ return "Congratulations, " + n; },
      tab: function(n){ return "🎓 " + String(n).split(" ")[0] + "'s graduation"; },
      fin: function(f){ return "Congratulations, " + f + "!"; },
      foot: function(n){ return "Congratulations, " + n + " — with love from all of us."; },
      noun: function(){ return "graduation keepsake"; } },
    farewell: { label: "Farewell", emoji: "✈️", heroEmoji: ["👋","✈️","💌"], festive: true, showNumber: false, mood: "warm",
      kicker: function(){ return "✨ Wishing you well on the next adventure ✨"; },
      reveal: function(n){ return "Farewell, " + n; },
      tab: function(n){ return "👋 " + String(n).split(" ")[0] + "'s send-off"; },
      fin: function(f){ return "We'll miss you, " + f + "!"; },
      foot: function(n){ return "We'll miss you, " + n + " — with love from all of us."; },
      noun: function(){ return "send-off keepsake"; } },
    memorial: { label: "In Memory", emoji: "🕊️", heroEmoji: ["🕊️","🌿","🕯️"], festive: false, showNumber: false, mood: "reflective",
      kicker: function(){ return "In loving memory"; },
      reveal: function(n){ return "Remembering " + n; },
      tab: function(n){ return "Remembering " + String(n).split(" ")[0]; },
      fin: function(f){ return "We love you, " + f; },
      foot: function(n){ return "In loving memory of " + n + " — held close by all of us."; },
      noun: function(){ return "memory book"; } },
  };
  function occasionPreset(key){ return OCCASIONS[key] || OCCASIONS.birthday; }

  // -------------------- grand reveal ceremony (movie script) --------------------
  // Flatten the grouped reveal into an ordered sequence of "slides": a title, then each
  // group's section card followed by its messages, then a finale.
  function ceremonyScript(groups){
    var steps = [{ type: "title" }];
    (groups || []).forEach(function(g){
      var items = g.items || [];
      if (!items.length) return;
      if (g.name) steps.push({ type: "section", name: g.name, count: items.length, intro: g.intro || "" });
      items.forEach(function(it){ steps.push({ type: "message", item: it }); });
    });
    steps.push({ type: "finale" });
    return steps;
  }

  // -------------------- beta-interest form (marketing landing) --------------------
  function validateBeta(p){
    var errs = [];
    if (!p || isBlank(p.name)) errs.push("Please enter your name.");
    if (!p || isBlank(p.email)) errs.push("Please enter your email.");
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(p.email).trim())) errs.push("That email doesn't look quite right.");
    return { ok: errs.length === 0, errors: errs };
  }

  // -------------------- writing prompts (composer inspiration) --------------------
  function writingPrompts(name, occasion){
    var n = (name || "").trim() || "them";
    // Occasion-flavored starters come FIRST (they're the three shown initially).
    var extras = {
      birthday: ["What do you wish " + n + " in the year ahead?", "Your favorite celebration with " + n + "."],
      retirement: ["Your favorite story from working with " + n + ".", "What work will miss most about " + n + ".", "Your wish for " + n + "'s next chapter."],
      anniversary: ["What their love has taught you.", "Your favorite story of the two of them together."],
      graduation: ["Your best advice for " + n + "'s next chapter.", "The moment you knew " + n + " would make it.", "What you're proudest of " + n + " for."],
      farewell: ["What you'll miss most about " + n + ".", "Your favorite memory of your time together.", "Your wish for " + n + "'s next adventure."],
      memorial: ["A story about " + n + " you want the family to have forever.", "How " + n + " changed your life.", "What you'd thank " + n + " for."],
    }[OCCASIONS[occasion] ? occasion : "birthday"] || [];
    return extras.concat([
      "What's your favorite memory of " + n + "?",
      "Finish the thought: “" + n + " always…”",
      "A lesson " + n + " taught you.",
      "The funniest thing " + n + " ever did.",
      "How did you and " + n + " first meet?",
      "What do you admire most about " + n + "?",
      "A small moment with " + n + " you'll never forget.",
      "Describe " + n + " in three words — and the story behind them.",
      "Something people might not know about " + n + ".",
      "A time " + n + " was there for you.",
      "What always makes you think of " + n + "?",
      "The best advice " + n + " ever gave you.",
    ]);
  }

  // -------------------- contributor emails (outreach export) --------------------
  // Unique emails contributors left. `all` = everyone (for showing them the reveal);
  // `promo` = only those who opted in to hear about making their own KeepSakePage.
  function contributorEmails(submissions){
    var all = {}, promo = {};
    (submissions || []).forEach(function(s){
      var e = String(s.email || "").trim(); if (!e) return;
      var k = e.toLowerCase();
      if (!all[k]) all[k] = e;
      if (s.promo && !promo[k]) promo[k] = e;
    });
    var vals = function(o){ return Object.keys(o).map(function(k){ return o[k]; }); };
    return { all: vals(all), promo: vals(promo) };
  }

  // -------------------- contributor tracking --------------------
  function normName(s){ return String(s || "").trim().toLowerCase().replace(/\s+/g, " "); }
  // Everyone who actually contributed, one row per person (by name), with the email they left and
  // how they relate to the invite list: "listed" (same email or no email to compare),
  // "different" (they typed a different email than the list has), or "new" (not on the list).
  function contributorDirectory(contributors, submissions){
    var rows = {}, order = [];
    (submissions || []).forEach(function(s){
      if (!s || s.status === "rejected") return;
      var k = normName(s.name); if (!k) return;
      var e = String(s.email || "").trim();
      if (!rows[k]) { rows[k] = { name: String(s.name || "").trim(), relationship: String(s.relationship || "").trim(), email: e, count: 0, emails: {} }; order.push(k); }
      var r = rows[k]; r.count++; if (e) { r.emails[e.toLowerCase()] = e; if (!r.email) r.email = e; } if (!r.relationship && s.relationship) r.relationship = String(s.relationship).trim();
    });
    var byName = {}, byEmail = {};
    (contributors || []).forEach(function(c){ byName[normName(c.name)] = c; var ce = String(c.contact || "").trim().toLowerCase(); if (ce.indexOf("@") > 0) byEmail[ce] = c; });
    return order.map(function(k){
      var r = rows[k]; var c = byName[k] || (r.email ? byEmail[r.email.toLowerCase()] : null);
      var listContact = c ? String(c.contact || "").trim() : "";
      var status = !c ? "new" : (r.email && listContact.indexOf("@") > 0 && listContact.toLowerCase() !== r.email.toLowerCase()) ? "different" : "listed";
      return { name: r.name, relationship: r.relationship, email: r.email, count: r.count, status: status, listContact: listContact, listId: c ? c.id : null };
    });
  }
  // Every email you have for a page's people: the invite list's plus what contributors typed, deduped.
  function allKnownEmails(contributors, submissions){
    var seen = {}, out = [];
    var add = function(e){ e = String(e || "").trim(); if (e.indexOf("@") < 1) return; var k = e.toLowerCase(); if (!seen[k]) { seen[k] = 1; out.push(e); } };
    (contributors || []).forEach(function(c){ add(c.contact); });
    (submissions || []).forEach(function(s){ if (s && s.status !== "rejected") add(s.email); });
    return out;
  }
  // A contributor is "submitted" if a submission's sender NAME matches, or its EMAIL matches the
  // invitee's contact (when that contact is an email), or the admin marked it done manually.
  function matchContributors(contributors, submissions){
    var byName = {}, byEmail = {};
    (submissions || []).forEach(function(s){
      byName[normName(s.name)] = true;
      var e = String(s.email || "").trim().toLowerCase(); if (e) byEmail[e] = true;
    });
    return (contributors || []).map(function(c){
      var cEmail = String(c.contact || "").trim().toLowerCase();
      var auto = !!byName[normName(c.name)] || (/@/.test(cEmail) && !!byEmail[cEmail]);
      return Object.assign({}, c, { autoMatched: auto, submitted: auto || !!c.manualDone });
    });
  }
  // Parse a pasted / uploaded invite list into [{name, contact, note}]. One person per line;
  // fields separated by comma or tab. Detects email (has @) and phone (7+ digits); "Name <email>"
  // is supported; a header row like "Name, Email" is skipped.
  function parseInviteList(text){
    var lines = String(text || "").split(/\r?\n/), out = [];
    lines.forEach(function(line, idx){
      var raw = line.trim(); if (!raw) return;
      if (idx === 0) { var low = raw.toLowerCase();
        if (/\bname\b/.test(low) && /(email|e-mail|phone|mobile|cell|contact)/.test(low)) return; }
      var parts = raw.split(/\t|,|;/).map(function(p){ return p.trim(); }).filter(function(p){ return p.length; });
      if (!parts.length) return;
      var name, rest, m = parts[0].match(/^(.*?)[<(]\s*([^>)\s]+@[^>)\s]+)\s*[>)]$/);
      if (m) { name = m[1].trim(); rest = [m[2]].concat(parts.slice(1)); }
      else { name = parts[0]; rest = parts.slice(1); }
      if (!name) return;
      var email = "", phone = "", notes = [];
      rest.forEach(function(t){
        if (!email && /@/.test(t)) email = t;
        else if (!phone && t.replace(/[^0-9]/g, "").length >= 7) phone = t;
        else notes.push(t);
      });
      out.push({ name: name, contact: email || phone, note: notes.join(" ") });
    });
    return out;
  }

  // A photo submission can carry up to 10 pictures, but surfaces that show one item at a
  // time (the highlight reel, the party wall) only ever rendered media[0] -- so everything
  // after the first photo was invisible. Expand those into one item per photo.
  function expandPhotos(list){
    var out = [];
    (list || []).forEach(function(m){
      var pics = (m && m.media || []).filter(function(x){ return x && x.kind === "photo"; });
      if (m && m.type === "photo" && pics.length > 1) {
        pics.forEach(function(pic, i){
          out.push(Object.assign({}, m, { id: String(m.id) + "#" + i, media: [pic] }));
        });
      } else if (m) {
        out.push(m);
      }
    });
    return out;
  }

  // -------------------- tile gallery --------------------
  // How long a full-screen slide stays up when nothing is playing. Video/voice return 0:
  // the show advances when the clip ends, not on a timer. Written notes get reading time
  // (TV-pace ~2.3 words/s plus a beat), clamped so a one-liner isn't gone in a blink and
  // an essay doesn't stall the room.
  function slideDuration(item){
    if (!item) return 7000;
    if (item.type === "video" || item.type === "voice") return 0;
    if (item.type === "written") {
      var words = String(item.text || "").trim().split(/\s+/).filter(Boolean).length;
      return Math.max(6000, Math.min(60000, Math.round(words / 2.3) * 1000 + 2000));
    }
    return 7000;
  }
  // A short, whole-word excerpt for a written-note tile.
  function tileExcerpt(text, max){
    max = max || 150;
    var t = String(text || "").replace(/\s+/g, " ").trim();
    if (t.length <= max) return t;
    var cut = t.slice(0, max);
    var sp = cut.lastIndexOf(" ");
    if (sp > max * 0.6) cut = cut.slice(0, sp);
    return cut.replace(/[,;:\-\u2014\s]+$/, "") + "\u2026";
  }

  // Gallery filters: media type, organizer category, and a name search. Pure, so the
  // reveal, the show and the tests all agree on what "visible" means.
  function filterTiles(tiles, f){
    f = f || {};
    var type = f.type && f.type !== "all" ? f.type : null;
    var group = f.group && f.group !== "all" ? f.group : null;
    var q = String(f.q || "").trim().toLowerCase();
    return (tiles || []).filter(function(t){
      if (!t) return false;
      if (type && t.type !== type) return false;
      if (group !== null && (t._group || "") !== (group === "__none" ? "" : group)) return false;
      if (q) {
        var hay = (String(t.name || "") + " " + String(t.relationship || "")).toLowerCase();
        if (hay.indexOf(q) < 0) return false;
      }
      return true;
    });
  }

  // -------------------- trailer --------------------
  // A movie-trailer cut of the whole tribute: a short window from every video and voice
  // memo, one punchy line from every written note, a quick beat on every photo, over the
  // song. The plan lives in config.trailer; the reveal plays it with the Trailer player.
  var TRAILER_DEF = { video: 5, voice: 5, photo: 4, quote: 4, title: 5, closing: 7, lead: 1 };   // photo 2.5 -> 4 (2026-10-20, owner)
  // The cold open: movie-trailer cards ("In a world where...") that play in silence before the
  // title card and the music. trailer.opener = one line per card; blank = no cold open.
  function openerLines(t){
    // Up to 24 cards (text + photo). A cap keeps a runaway paste from becoming a ten-minute opener.
    return String((t && t.opener) || "").split(/\n+/).map(function(x){ return x.trim(); }).filter(Boolean).slice(0, 24);
  }
  // A cold-open line can be a photo card: "[photo 2]" or "[photo 2] Storm Tracker John" (the
  // text becomes a caption over the picture). Photos live in trailer.openerPhotos = [{url}].
  function parseOpenerLine(line, photos){
    var m = String(line || "").match(/^\[photo\s*(\d+)\]\s*(.*)$/i);
    if (!m) return { text: String(line || ""), img: null, cap: "" };
    var ph = (photos || [])[+m[1] - 1];
    return { text: m[2] || "", img: ph ? ph.url : null, cap: m[2] || "", missing: !ph };
  }
  // A " / " inside a card's line is a deliberate line break ("Some know him as / Storm Tracker John").
  function openerBreaks(line){ return String(line || "").split(/\s*\/\s*/).map(function(x){ return x.trim(); }).filter(Boolean); }
  // Reading time per card: unhurried, trailer-voice pacing.
  function openerDuration(line){
    if (/^\[photo\s*\d+\]/i.test(String(line || ""))) return 3.5;      // a picture holds for a beat
    var w = String(line || "").trim().split(/\s+/).filter(Boolean).length;
    return Math.max(2.8, Math.min(7, 1.4 + w / 2.2));
  }
  // With a recorded voiceover, the cards are paced so their total equals the recording's
  // length (each keeps its share of the reading time; never under 1.5s). Without one, or
  // with an unknown length, the normal reading-time pacing stands.
  // Pauses in a voiceover: windows of `win` seconds whose loudness is under `frac` of the
  // recording's loudest window, lasting at least `minLen`. Returns [{start,end,len}].
  function findSilences(samples, rate, opts){
    opts = opts || {}; var win = opts.win || 0.05, frac = opts.frac || 0.08, minLen = opts.minLen || 0.45;
    var n = Math.floor(win * rate), rms = [], peak = 0;
    for (var i = 0; i + n <= samples.length; i += n) { var acc = 0; for (var j = i; j < i + n; j++) acc += samples[j] * samples[j]; var v = Math.sqrt(acc / n); rms.push(v); if (v > peak) peak = v; }
    var thr = peak * frac, out = [], st = -1;
    for (var k = 0; k <= rms.length; k++) {
      var quiet = k < rms.length && rms[k] < thr;
      if (quiet && st < 0) st = k;
      if (!quiet && st >= 0) { var len = (k - st) * win; if (len >= minLen) out.push({ start: +(st * win).toFixed(2), end: +(k * win).toFixed(2), len: +len.toFixed(2) }); st = -1; }
    }
    return out;
  }
  // Line up the cold-open cards with a voiceover. Spoken (text) cards start when the voice
  // resumes after a pause; photo cards sit inside the pause after the line before them.
  // Returns { cues:[start seconds per card], ok, note }. Needs (spoken cards - 1) pauses;
  // uses the longest ones, in order. With too few pauses it reports ok:false.
  function syncCuesToVoice(lines, silences, voLen, photos){
    var cards = (lines || []).map(function(l){ return parseOpenerLine(l, photos); });
    var n = cards.length; if (!n) return { cues: [], ok: false, note: "no cards" };
    var spoken = []; cards.forEach(function(c, i){ if (!c.img) spoken.push(i); });
    var sil = (silences || []).slice();
    var lead = sil.length && sil[0].start <= 0.05 ? sil.shift() : null;             // silence before the first word
    var trail = sil.length && voLen && sil[sil.length - 1].end >= voLen - 0.1 ? sil.pop() : null;   // after the last word
    var need = Math.max(0, spoken.length - 1);
    if (sil.length < need) return { cues: null, ok: false, note: "found " + sil.length + " pause" + (sil.length === 1 ? "" : "s") + " but the " + spoken.length + " spoken cards need " + need };
    var chosen = sil.slice().sort(function(a, b){ return b.len - a.len; }).slice(0, need).sort(function(a, b){ return a.start - b.start; });
    var cues = new Array(n).fill(0);
    // spoken card j starts at the end of pause j-1 (a touch early so the words don't beat it)
    spoken.forEach(function(ci, j){ cues[ci] = j === 0 ? (lead ? Math.max(0, lead.end - 0.15) : 0) : Math.max(0, chosen[j - 1].end - 0.15); });
    // photo cards: spread across the pause that follows the previous spoken card
    var i = 0;
    while (i < n) {
      if (!cards[i].img) { i++; continue; }
      var run = []; while (i < n && cards[i].img) { run.push(i); i++; }
      var prevSpoken = -1; for (var q = run[0] - 1; q >= 0; q--) if (!cards[q].img) { prevSpoken = q; break; }
      var pause;
      if (prevSpoken < 0) pause = { start: 0, end: lead ? lead.end : (spoken.length ? cues[spoken[0]] : voLen || 3.5 * run.length) };
      else { var j = spoken.indexOf(prevSpoken); pause = j < spoken.length - 1 ? chosen[j] : { start: trail ? trail.start : (voLen || 0), end: voLen || (trail ? trail.end : 0) }; }
      var span = Math.max(0.8 * run.length, (pause.end || 0) - (pause.start || 0));
      run.forEach(function(ci, r){ cues[ci] = +(pause.start + 0.1 + (span - 0.1) * r / run.length).toFixed(2); });
    }
    // monotonic, 0.8s apart at least
    for (var m = 1; m < n; m++) if (cues[m] < cues[m - 1] + 0.8) cues[m] = +(cues[m - 1] + 0.8).toFixed(2);
    return { cues: cues, ok: true, note: "" };
  }
  // Card durations from cue times (the last card runs to the end of the recording).
  function cueDurations(cues, voLen){
    var out = []; for (var i = 0; i < cues.length; i++) { var end = i + 1 < cues.length ? cues[i + 1] : (voLen || cues[i] + 3.5); out.push(Math.max(0.8, +(end - cues[i]).toFixed(2))); }
    return out;
  }
  function openerPaced(lines, voLen){
    var durs = (lines || []).map(openerDuration);
    var sum = durs.reduce(function(a, b){ return a + b; }, 0);
    if (!(voLen > 0) || !sum) return durs;
    var k = voLen / sum;
    return durs.map(function(d){ return Math.max(1.5, +(d * k).toFixed(2)); });
  }
  // A starter the organizer can edit — the shape of the joke, with the honoree's name in it.
  function defaultOpener(config){
    var c = config || {}; var name = String(c.displayName || c.honoreeName || "him").split(" ")[0];
    var age = c.age ? ordinal(c.age) : "big";
    if (c.occasion === "memorial") return "";
    return [
      "In a world where most people slow down\u2026",
      "one man refused to get the memo.",
      "He has a story for every occasion.",
      "Most of them are even true.",
      "This " + (c.eventDate ? new Date(c.eventDate + "T00:00:00").toLocaleDateString(undefined, { month: "long" }) : "year") + "\u2026",
      "the people who love " + name + " have something to say.",
      "Rated: " + age + " birthday.",
    ].join("\n");
  }
  // The stinger: a post-credits ad for KeepSakePage that plays after the closing card, in the
  // cold-open style. trailer.stinger = one line per card (same "/" breaks + "Rated:" tag as the
  // cold open); blank = none. A logo card with the Play-again buttons always ends it.
  function stingerLines(t){ return openerLines({ opener: t && t.stinger }); }
  // Add a query param to a URL that may already carry a #hash (the query must sit before it,
  // or location.search never sees it): withQuery("/p#reveal=x","prep=1") -> "/p?prep=1#reveal=x".
  function withQuery(url, q){
    var u = String(url || ""), h = ""; var k = u.indexOf("#"); if (k >= 0) { h = u.slice(k); u = u.slice(0, k); }
    return u + (u.indexOf("?") >= 0 ? "&" : "?") + q + h;
  }
  // Cold-open music (a dramatic bed under the cards + voiceover): 0.05..0.9, default 45%
  // (it sits under a voiceover; the main song lands on the title card at full level).
  function openMusicLevel(t){ var v = +(t && t.openMusicVol); if (!(v > 0)) v = 0.45; return Math.max(0.05, Math.min(0.9, v)); }
  function defaultStinger(config){
    var c = config || {}; var name = String(c.displayName || c.honoreeName || "him").split(" ")[0];
    return [
      "And now, / a word from our sponsor.",
      "KeepSakePage.com — a website built / by " + name + "'s son. / With his life savings. / Allegedly.",
      "Birthdays. Anniversaries. Retirements. / Anyone who ever taught you / how to tie a tie.",
      "Rated: SP \u2014 Shameless Promotion. / May contain a business plan.",
    ].join("\n");
  }
  var QUOTE_WORDS = /\b(love|laugh|happy|best|thank|always|never|remember|friend|family|gentleman|heart|proud|lucky|joy|smile|honor|memor|grateful|cherish|kind)\w*/i;

  // Split text into sentences (keeps the terminal punctuation). Line breaks count as
  // breaks too — plenty of notes are written one thought per line with no punctuation.
  function sentences(text){
    var out = [];
    String(text || "").split(/\n+/).forEach(function(line){
      var t = line.replace(/\s+/g, " ").trim(); if (!t) return;
      (t.match(/[^.!?]+[.!?]+["\u201d']?|[^.!?]+$/g) || []).forEach(function(x){ x = x.trim(); if (x) out.push(x); });
    });
    return out;
  }
  var SIGNOFF = /^(love|with love|much love|lots of love|all our love|sincerely|warmly|cheers|best|all the best|thanks|thank you|thanks again|god bless|xo+|hugs|yours)\b[\s,.!\-\u2013\u2014]*[A-Za-z&' ]{0,40}$|[\-\u2013\u2014]\s*[A-Z][A-Za-z&'. ]{1,30}$|^p\.?s\.?\b/i;
  var GREETING = /^(happy (\d+\w*\s+)?birthday|happy \w+|dear|hi|hello|hey|congratulations)\b/i;
  function wordCount(x){ return String(x || "").trim().split(/\s+/).filter(Boolean).length; }
  // Strip a leading salutation ("Dear John, " / "Hi JT! ") so the line starts on the thought.
  function desalute(x){ return String(x || "").replace(/^(dear|hi|hello|hey|happy birthday)\b[^,!.:]{0,40}[,!:]\s*/i, "").replace(/^["\u201c]+|["\u201d]+$/g, "").trim(); }
  // The most quotable line of a note: one complete thought that fits on a screen, preferably
  // with a feeling word in it. Greetings, sign-offs and name-only fragments are skipped.
  // Never rewrites — only picks (and drops a salutation).
  function pickQuote(text, max){
    max = max || 120;
    var ss = sentences(text);
    if (!ss.length) return "";
    var best = null, bestScore = -Infinity, longest = "";
    ss.forEach(function(x){
      var c = desalute(x); var w = wordCount(c);
      if (!c || c.length > max) return;
      if (w < 3 || c.length < 12) return;                                  // "John!" / "!" fragments
      if (SIGNOFF.test(c)) return;                                           // "Love, Ann & Bert" / "- Caroline"
      var sc = 0;
      if (QUOTE_WORDS.test(c)) sc += 2;
      if (/!/.test(c) && w >= 4) sc += 0.5;
      if (GREETING.test(c)) sc -= 2;                                         // "Happy 80th Birthday!!" is filler
      if (w >= 6 && w <= 18) sc += 1;                                        // reads well in one breath
      if (/\b(i|we|you|your)\b/i.test(c)) sc += 0.5;                        // said to him, not about the day
      if (sc > bestScore) { bestScore = sc; best = c; }
      if (c.length > longest.length) longest = c;
    });
    if (best) return best;
    // Nothing clean: the longest usable clause, or a trimmed excerpt of the first line.
    return longest || tileExcerpt(desalute(ss[0]) || ss[0], max);
  }

  // Draft a plan from the reveal's messages (in reveal order). One clip per video / voice /
  // photo, one quote per written note. Windows come from TRAILER_DEF; fitTrailer trims them.
  function buildTrailerPlan(messages, opts){
    opts = opts || {}; var d = Object.assign({}, TRAILER_DEF, opts.def || {});
    var clips = [];
    (messages || []).forEach(function(m){
      if (!m) return;
      var base = { sub: m.id, name: m.name || "", rel: m.relationship || "", on: true };
      var media = m.media || [];
      if (m.type === "video" && media[0] && (media[0].url || media[0].path)) {   // a bare storage path resolves through mediaSrc / the worker (private bucket, 2026-10-11)
        clips.push(Object.assign({}, base, { k: "video", url: media[0].url || media[0].path, start: d.lead, end: d.lead + d.video, cap: media[0].caption || "" }));
      } else if (m.type === "voice" && media[0] && (media[0].url || media[0].path)) {
        clips.push(Object.assign({}, base, { k: "voice", url: media[0].url || media[0].path, start: 0, end: d.voice, cap: media[0].caption || "" }));
      } else if (m.type === "photo") {
        media.forEach(function(x, i){ if (x && x.kind === "photo" && (x.url || x.path)) clips.push(Object.assign({}, base, { k: "photo", url: x.url || x.path, mi: i, dur: d.photo, cap: x.caption || "" })); });
      } else if (m.type === "written" && String(m.text || "").trim()) {
        clips.push(Object.assign({}, base, { k: "quote", text: pickQuote(m.text), dur: d.quote }));
      }
    });
    clips.forEach(function(c, i){ c.id = String(c.sub) + ":" + c.k + ":" + (c.mi || 0); });
    return clips;
  }
  function clipSeconds(c){
    if (!c || c.on === false) return 0;
    if (c.k === "video" || c.k === "voice") {
      if (c.end == null || !isFinite(+c.end)) return +c.len > 0 ? +c.len - (+c.start || 0) : 45;   // plays to the end; 45s is the estimate for the clock
      return Math.max(0, (+c.end || 0) - (+c.start || 0));
    }
    return +c.dur || 0;
  }
  // The full reveal: the trailer's running order, but every contribution (on or off), every
  // recording start to finish, every note in full, and anything approved since the plan was
  // built appended at the end. end:null means "play until it ends".
  function fullRevealClips(plan, messages){
    var byId = {}; (messages || []).forEach(function(m){ if (m && m.id) byId[m.id] = m; });
    var inPlan = {};
    var out = (plan || []).map(function(c){ inPlan[c.sub] = true; return Object.assign({}, c); });
    var extra = (messages || []).filter(function(m){ return m && !inPlan[m.id]; });
    out = out.concat(buildTrailerPlan(extra));
    return out.map(function(c){
      var n = Object.assign({}, c, { on: true }); delete n.unplaced; delete n.why;
      if (n.k === "video" || n.k === "voice") { n.start = 0; n.end = null; }
      else if (n.k === "quote") { var m = byId[n.sub]; var txt = String((m && m.text) || n.text || "").trim(); n.text = txt; n.dur = slideDuration({ type: "written", text: txt }) / 1000; }
      else if (n.k === "photo") { n.dur = n.durLock ? Math.max(3.5, +n.dur || 3.5) : 3.5; }
      return n;
    });
  }
  function trailerSeconds(clips, def){
    var d = Object.assign({}, TRAILER_DEF, def || {});
    return (clips || []).reduce(function(a, c){ return a + clipSeconds(c); }, 0) + d.title + d.closing;
  }
  // Trim to a target length without dropping anybody: shorten video/voice windows first
  // (never below 3s), then photos (2s), then quotes (3s), then thin the photos to every
  // other one. Videos are never switched off by the fitter — that's the organizer's call.
  function fitTrailer(clips, targetSec){
    var out = (clips || []).map(function(c){ return Object.assign({}, c); });
    if (!targetSec || trailerSeconds(out) <= targetSec) return out;
    var steps = [
      function(){ out.forEach(function(c){ if ((c.k === "video" || c.k === "voice") && c.on !== false) { var len = clipSeconds(c); if (len > 4) c.end = +(c.start + 4).toFixed(1); } }); },
      function(){ out.forEach(function(c){ if (c.k === "photo" && !c.durLock) c.dur = Math.min(c.dur, 2); }); },
      function(){ out.forEach(function(c){ if (c.k === "quote" && !c.durLock) c.dur = Math.min(c.dur, 3); }); },
      function(){ out.forEach(function(c){ if ((c.k === "video" || c.k === "voice") && c.on !== false) { var len = clipSeconds(c); if (len > 3) c.end = +(c.start + 3).toFixed(1); } }); },
      function(){ var n = 0; out.forEach(function(c){ if (c.k === "photo" && c.on !== false) { n++; if (n % 2 === 0) c.on = false; } }); },
    ];
    for (var i = 0; i < steps.length && trailerSeconds(out) > targetSec; i++) steps[i]();
    return out;
  }
  function fmtSecs(s){ s = Math.max(0, Math.round(s || 0)); return Math.floor(s / 60) + ":" + String(s % 60).padStart(2, "0"); }

  // A "soundtrack clip": one video (Porter at the piano) that takes the screen for a while
  // and then keeps playing as the music bed under everything after it. It's pulled out of
  // the running order and scheduled by the player.
  function trailerSequence(clips, bed){
    var on = (clips || []).filter(function(c){ return c && c.on !== false; });
    var bedClip = (bed && bed.clipId) ? on.filter(function(c){ return c.id === bed.clipId && c.k === "video"; })[0] || null : null;
    return { seq: bedClip ? on.filter(function(c){ return c.id !== bedClip.id; }) : on, bedClip: bedClip };
  }
  // When does the soundtrack clip take over? After the song has looped `afterLoops` times
  // (0 = the moment it's reached), or — so it can never be skipped — before the closing card.
  function bedReady(songLoops, afterLoops, hasSong, beforeClosing){
    if (beforeClosing) return true;
    if (!hasSong) return true;
    return (songLoops || 0) >= (afterLoops || 0);
  }
  function bedOnScreen(bed){ var n = bed && +bed.onScreen; return (n > 0 ? Math.min(600, n) : 60); }
  // The soundtrack clip's audio window: from the clip's start point to `audioEnd` (seconds
  // into the video; null = its natural end), looping back to the start point if `loop`.
  function bedAudio(bed, clip){
    var start = +(clip && clip.start) || 0, end = bed && +bed.audioEnd > start ? +bed.audioEnd : null;
    return { start: start, end: end, loop: !!(bed && bed.loop) };
  }
  // The trailer's playlist: its own song (else the reveal soundtrack), then an optional second
  // song that plays after it. The list repeats; the soundtrack clip counts finished songs.
  // The songs the family can play and download from the reveal page: the trailer's songs
  // (and the reveal soundtrack if it's a different file). Titles come from the upload
  // name; download links use storage's ?download= so the browser saves instead of playing.
  function songTitle(name, url){
    var base = String(name || "").trim();
    if (!base && /^data:/i.test(String(url || ""))) return "Song";
    if (!base) { base = String(url || "").split("?")[0].split("/").pop() || "Song"; base = base.replace(/^[a-z0-9]{8,16}_/i, ""); }
    base = base.replace(/\.[a-z0-9]{2,4}$/i, "").replace(/[_]+/g, " ").trim();
    base = base.replace(/^\d{1,3}\s*[-.\u2013\u2014]\s+/, "").replace(/^\d{1,3}\s+(?=[A-Za-z])/, "").trim();   // "08 - Title" / "03. Title" / "12 Title"
    return base || "Song";
  }
  function songExt(url){ var m = String(url || "").split("?")[0].match(/\.([a-z0-9]{2,4})$/i); return m ? m[1].toLowerCase() : "mp3"; }
  function revealSongs(config){
    var t = (config && config.trailer) || {}, out = [], seen = {};
    [[t.musicUrl, t.musicName, t.musicTitle, t.musicBy], [t.music2Url, t.music2Name, t.music2Title, t.music2By], [t.music3Url, t.music3Name, t.music3Title, t.music3By], [config && config.musicUrl, config && config.musicName, t.musicUrl ? "" : t.musicTitle, t.musicUrl ? "" : t.musicBy]].forEach(function(pair){
      var u = pair[0]; if (!u || seen[u]) return; seen[u] = true;
      var title = String(pair[2] || "").trim() || songTitle(pair[1], u), file = safeName(title) + "." + songExt(u), by = String(pair[3] || "").trim();
      var dl = /^https?:\/\//i.test(u) ? u + (u.indexOf("?") < 0 ? "?" : "&") + "download=" + encodeURIComponent(file) : u;
      out.push({ title: title, by: by, url: u, download: dl, file: file });
    });
    return out;
  }
  // trailer.playlist is the play order as song slots, e.g. [1,2,1] = song 1, song 2, song 1
  // again, then the whole thing repeats. Without one: song 1 then song 2 (identical files once).
  // Three song slots: 1 = the trailer song (else the reveal soundtrack), 2 and 3 = optional extras.
  var SONG_SLOTS = [1, 2, 3];
  function trailerSlots(t, config){
    return { 1: (t && t.musicUrl) || (config && config.musicUrl) || "", 2: (t && t.music2Url) || "", 3: (t && t.music3Url) || "" };
  }
  function slotTitleKey(n){ return n === 1 ? "musicTitle" : n === 2 ? "music2Title" : "music3Title"; }
  function slotByKey(n){ return n === 1 ? "musicBy" : n === 2 ? "music2By" : "music3By"; }
  function slotTitleUrlKey(n){ return n === 1 ? "musicTitleUrl" : n === 2 ? "music2TitleUrl" : "music3TitleUrl"; }   // 2026-10-20: the file a custom title/credit was written for
  function slotTitleLive(t, config, n){ var u = String((t && t[slotTitleUrlKey(n)]) || ""); return !u || u === trailerSlots(t, config)[n]; }   // no record = legacy, honoured
  function slotBy(t, n, config){ return slotTitleLive(t, config, n) ? String((t && t[slotByKey(n)]) || "").trim() : ""; }
  function slotName(t, config, n){
    var slots = trailerSlots(t, config);
    var custom = slotTitleLive(t, config, n) ? String((t && t[slotTitleKey(n)]) || "").trim() : ""; if (custom) return custom;
    var raw = n === 1 ? ((t && t.musicName) || (config && config.musicName)) : n === 2 ? (t && t.music2Name) : (t && t.music3Name);
    return songTitle(raw, slots[n]);
  }
  function trailerTracks(t, config){
    var slots = trailerSlots(t, config), out = [];
    var order = (t && Array.isArray(t.playlist) && t.playlist.length) ? t.playlist : null;
    (order || SONG_SLOTS).forEach(function(n){ var u = slots[n]; if (!u) return; if (!order && out.indexOf(u) >= 0) return; out.push(u); });
    return out;
  }
  // Per-slot trim: {start,end} seconds (end null/0 = natural end). Stored as trailer.trim1/trim2/trim3.
  function slotTrim(t, n){ var tr = (t && t["trim" + n]) || {}; var st = Math.max(0, +tr.start || 0), en = +tr.end > st ? +tr.end : null; return { start: st, end: en }; }
  // The playlist as playable entries {slot,url,start,end}, following the play order.
  function trailerTrackList(t, config){
    var slots = trailerSlots(t, config), out = [];
    var order = (t && Array.isArray(t.playlist) && t.playlist.length) ? t.playlist : null;
    (order || SONG_SLOTS).forEach(function(n){ var u = slots[n]; if (!u) return; if (!order && out.some(function(x){ return x.url === u; })) return; var tr = slotTrim(t, n); out.push({ slot: n, url: u, start: tr.start, end: tr.end }); });
    return out;
  }
  // When each song starts and ends in the show, given each slot's full length (seconds) and
  // trims; the list runs through `afterLoops` songs and reports when the soundtrack clip is due.
  function musicTimeline(t, config, lengths, afterLoops){
    var list = trailerTrackList(t, config); if (!list.length) return { songs: [], bedAt: null };
    var n = Math.max(1, +afterLoops || 0), at = 0, songs = [];
    for (var i = 0; i < n; i++) {
      var e = list[i % list.length]; var full = +(lengths || {})[e.slot] || 0;
      var len = full ? Math.max(0, (e.end != null ? Math.min(e.end, full) : full) - Math.min(e.start, full)) : null;
      songs.push({ slot: e.slot, start: at, end: len != null ? at + len : null, len: len });
      if (len == null) return { songs: songs, bedAt: null };
      at += len;
    }
    return { songs: songs, bedAt: (+afterLoops || 0) > 0 ? at : 0 };
  }
  // Music level under a video / voice memo, as a fraction of its normal level (default 10%).
  function duckLevel(t){ var d = +(t && t.duck); if (!(d > 0)) d = 0.10; return Math.max(0.02, Math.min(0.6, d)); }
  // Which songs play before the soundtrack clip takes over, by slot, following the repeat.
  function songsBeforeBed(t, config, afterLoops){
    var slots = trailerSlots(t, config);
    var order = ((t && Array.isArray(t.playlist) && t.playlist.length) ? t.playlist : SONG_SLOTS).filter(function(n){ return !!slots[n]; });
    if (!order.length) return [];
    var n = Math.max(0, +afterLoops || 0), out = [];
    for (var i = 0; i < n; i++) out.push(order[i % order.length]);
    return out;
  }

  // Captions come from Whisper's timestamped segments; an organizer's edit in Review changes
  // the transcript TEXT only. Re-flow the edited words over the same timings: each segment
  // keeps its share of the words (by its original word count), so a fixed name or a removed
  // "um" lands where the original did. Unchanged text passes straight through.
  function reflowCaptions(segments, editedText){
    var segs = (segments || []).filter(function(x){ return x && x.length >= 3; });
    if (!segs.length) return segs;
    var joined = segs.map(function(x){ return String(x[2] || "").trim(); }).join(" ").replace(/\s+/g, " ").trim();
    var edited = String(editedText || "").replace(/\s+/g, " ").trim();
    if (!edited || edited === joined) return segs;
    var words = edited.split(" "), counts = segs.map(function(x){ return String(x[2] || "").trim().split(/\s+/).filter(Boolean).length || 1; });
    var total = counts.reduce(function(a, b){ return a + b; }, 0), out = [], pos = 0;
    segs.forEach(function(x, i){
      var take = i === segs.length - 1 ? words.length - pos : Math.round(words.length * counts[i] / total);
      take = Math.max(0, Math.min(take, words.length - pos));
      var text = words.slice(pos, pos + take).join(" "); pos += take;
      if (text) out.push([x[0], x[1], text]);
    });
    return out;
  }
  // Whisper often returns one long segment per sentence. Split anything over `maxWords` into
  // phrase-sized pieces (breaking at commas/clauses when it can), spreading the segment's time
  // across them by word count — so a caption is a readable line, not a paragraph.
  function splitCaptions(segments, maxWords){
    maxWords = maxWords || 8; var out = [];
    (segments || []).forEach(function(sg){
      var st = +sg[0], en = +sg[1], text = String(sg[2] || "").replace(/\s+/g, " ").trim(); if (!text) return;
      var words = text.split(" "); if (words.length <= maxWords) { out.push([st, en, text]); return; }
      var chunks = [], cur = [];
      words.forEach(function(w){ cur.push(w); var clause = /[,;:]$/.test(w) && cur.length >= 3; if (cur.length >= maxWords || clause) { chunks.push(cur); cur = []; } });
      if (cur.length) { if (cur.length < 3 && chunks.length) chunks[chunks.length - 1] = chunks[chunks.length - 1].concat(cur); else chunks.push(cur); }
      var total = words.length, t = st;
      chunks.forEach(function(c, i){ var d = (en - st) * c.length / total; var e2 = i === chunks.length - 1 ? en : +(t + d).toFixed(2); out.push([+t.toFixed(2), e2, c.join(" ")]); t = e2; });
    });
    return out;
  }
  // On-screen pull quotes for a clip: keep the ones inside its window, in order, no overlap.
  function cleanPops(quotes, start, end){
    var st = +start || 0, en = (end == null || !isFinite(+end)) ? Infinity : +end, out = [], last = -1;
    (quotes || []).slice().sort(function(a, b){ return (+a.start || 0) - (+b.start || 0); }).forEach(function(q){
      var a = +q.start, b = +q.end, t = String(q.text || "").trim().replace(/^["\u201c]+|["\u201d.]+$/g, "");
      if (!isFinite(a) || !t || a < st - 0.2 || a >= en - 0.5) return;
      if (!isFinite(b) || b <= a) b = a + 3; b = Math.min(b, en, a + 4.5);
      if (a < last) return;
      out.push({ at: +a.toFixed(2), end: +b.toFixed(2), text: t.slice(0, 80) }); last = b;
    });
    return out.slice(0, 3);
  }
  // Apply the AI director's cut to a plan: per-clip windows (validated + padded a beat so
  // cuts don't clip a consonant), verbatim quotes, the running order, and drops. Pure.
  function applyDirectorCut(plan, cut, durations){
    cut = cut || {}; durations = durations || {};
    var byId = {}; (cut.clips || []).forEach(function(c){ if (c && c.id) byId[c.id] = c; });
    var quotes = cut.quotes || {};
    var drop = {}; (cut.drop || []).forEach(function(id){ drop[id] = true; });
    var out = (plan || []).map(function(c){
      var n = Object.assign({}, c);
      if ((c.k === "video" || c.k === "voice") && byId[c.id]) {
        var w = byId[c.id], dur = +durations[c.url] || +durations[c.id] || 0;
        var st = Math.max(0, (+w.start || 0) - 0.25), en = (+w.end || 0) + 0.35;
        if (dur > 0) en = Math.min(en, dur);
        if (en - st < 2) en = st + Math.min(6, dur > 0 ? Math.max(2, dur - st) : 6);
        if (en - st > 22) en = st + 22;
        if (en > st) { n.start = +st.toFixed(2); n.end = +en.toFixed(2); n.why = String(w.why || "").slice(0, 140); }
      }
      if (c.k === "quote" && quotes[c.sub]) { var q = String(quotes[c.sub]).trim(); if (q.length >= 6) n.text = q.slice(0, 180); }
      if (drop[c.id]) n.on = false;
      return n;
    });
    var order = Array.isArray(cut.order) ? cut.order : [];
    if (order.length) {
      var seen = {}; var ordered = [];
      // A placement is an explicit include: it overrides an "off" left by an earlier run.
      order.forEach(function(id){ out.forEach(function(c){ if (c.id === id && !seen[c.id]) { seen[c.id] = true; if (!drop[c.id]) { c.on = true; delete c.unplaced; } ordered.push(c); } }); });
      // Anything the director neither placed nor dropped goes to the tail, switched OFF and
      // flagged — a curated cut can't have unreviewed items with default windows in it. The
      // organizer can flip any of them back on.
      out.forEach(function(c){ if (!seen[c.id]) { if (!drop[c.id]) { c.on = false; c.unplaced = true; } ordered.push(c); } });
      out = ordered;
    }
    return out;
  }

  // -------------------- party-night prefetch --------------------
  // Every remote file the reveal + ceremony will need, deduped. Data-URIs are already
  // local (mock mode) so they're skipped — only http(s) needs warming into the cache.
  function revealMediaUrls(data){
    var out = [], seen = {};
    function add(u){
      if (!u || typeof u !== "string") return;
      if (!/^https?:\/\//i.test(u)) return;
      if (seen[u]) return;
      seen[u] = true; out.push(u);
    }
    var c = (data && data.config) || {};
    add(c.headerPhotoUrl); add(c.musicUrl);
    if (c.trailer) { add(c.trailer.musicUrl); add(c.trailer.music2Url); add(c.trailer.music3Url); add(c.trailer.voUrl); add(c.trailer.openMusicUrl); add(c.trailer.stVoUrl); (c.trailer.openerPhotos || []).forEach(function(ph){ add(ph && ph.url); }); (c.trailer.clips || []).forEach(function(k){ add(k && k.url); }); }
    if (c.honoreeReply) add(c.honoreeReply.url);
    if (c.reaction) add(c.reaction.url);
    (c.milestones || []).forEach(function(m){ add(m && m.photoUrl); });
    Object.keys(c.animations || {}).forEach(function(k){ add(c.animations[k]); });
    (data && data.messages || []).forEach(function(m){
      (m.media || []).forEach(function(x){ add(x && x.url); });
    });
    (data && data.groups || []).forEach(function(g){
      (g.items || []).forEach(function(m){ (m.media || []).forEach(function(x){ add(x && x.url); }); });
    });
    (data && data.photoWall || []).forEach(function(p){ add(p && p.url); });
    return out;
  }

  // -------------------- multi-page (slugs + occasion templates) --------------------
  // A "page" is one tribute (one honoree) at keepsakepage.com/<slug>.
  var RESERVED_SLUGS = ["admin","api","app","apps","assets","beta","blog","create","css","demo","docs",
    "help","home","img","index","js","keepsake","keepsakepage","login","new","page","pages","privacy",
    "reveal","signin","signup","static","support","terms","www"];
  function slugify(name){
    var s = String(name || "").toLowerCase();
    try { s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); } catch (e) {}
    s = s.replace(/['’]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/-{2,}/g, "-").replace(/^-+|-+$/g, "");
    return s.slice(0, 40).replace(/-+$/, "");
  }
  function validateSlug(slug){
    var s = String(slug || "");
    if (s.length < 2) return { ok: false, error: "The address needs at least 2 characters." };
    if (s.length > 40) return { ok: false, error: "Keep the address under 40 characters." };
    if (!/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/.test(s)) return { ok: false, error: "Lowercase letters, numbers, and dashes only (no leading/trailing dash)." };
    if (RESERVED_SLUGS.indexOf(s) >= 0) return { ok: false, error: "That address is reserved — try adding a name or year." };
    return { ok: true };
  }
  // Short-link word (keepsakepage.com/<word>): same alphabet as a page address, 3-24 chars.
  // Two short links per page: the reveal link (shortWord/viewPassHash) and a trailer-only link
  // (trailerWord/trailerPassHash) that opens the page in trailer-only mode. Same word rules.
  var LINK_KINDS = { reveal: { word: "shortWord", pass: "viewPassHash" }, trailer: { word: "trailerWord", pass: "trailerPassHash" } };
  function linkFields(kind){ return LINK_KINDS[kind === "trailer" ? "trailer" : "reveal"]; }
  // Where a short link lands: the reveal hash, plus &trailer=1 for a trailer-only link.
  function revealPath(r){ return "/" + r.slug + "#reveal=" + encodeURIComponent(r.token) + (r.kind === "trailer" ? "&trailer=1" : ""); }
  function validateShortWord(w){
    var x = String(w || "").trim().toLowerCase();
    if (!x) return { ok: true, word: "" };
    if (x.length < 3 || x.length > 24) return { ok: false, error: "Use 3-24 characters." };
    if (!/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/.test(x)) return { ok: false, error: "Lowercase letters, numbers and dashes only." };
    if (RESERVED_SLUGS.indexOf(x) >= 0) return { ok: false, error: "That word is reserved - try another." };
    return { ok: true, word: x };
  }
  // Seed a new page's config from the occasion. Returns a config PATCH (merged over defaults).
  function occasionTemplate(occasion, honoree, age){
    var key = OCCASIONS[occasion] ? occasion : "birthday";
    var name = String(honoree || "").trim() || "Someone Wonderful";
    var first = name.split(" ")[0];
    var preset = OCCASIONS[key];
    var a = preset.showNumber ? (parseInt(age, 10) || "") : "";
    var intro = {
      birthday: "We're collecting " + (a ? ordinal(a) + " " : "") + "birthday wishes for " + name + " — a surprise keepsake of notes, photos, and videos from everyone who loves " + first + ". Add yours below; it stays secret until the big reveal.",
      retirement: "After a wonderful career, " + name + " is retiring — and we're gathering notes, photos, and videos from colleagues and friends into one keepsake. Add yours below; it stays secret until the send-off.",
      anniversary: "We're celebrating " + name + (a ? " — " + a + " years together" : "'s anniversary") + " with a keepsake of memories from the people who've shared the journey. Add yours below; it stays secret until the celebration.",
      graduation: "The tassel's turned! We're collecting congratulations for " + name + "'s graduation — notes, photos, and videos from everyone cheering " + first + " on. Add yours below; it stays secret until the celebration.",
      farewell: name + " is off on a new adventure — we're gathering send-off wishes, memories, and photos from everyone who'll miss " + first + ". Add yours below; it stays secret until the goodbye.",
      memorial: "We're gathering memories of " + name + " — stories, photos, and words of love from everyone whose life " + first + " touched. Please add yours; together they become a keepsake for the family.",
    }[key];
    // Starter category buckets (the organizer can rename/remove them in Organize).
    var groups = {
      birthday: ["From the family", "From friends"],
      retirement: ["From colleagues", "From friends & family"],
      anniversary: ["Family", "Friends"],
      graduation: ["Family", "Friends", "Classmates & teachers"],
      farewell: ["From colleagues", "From friends"],
      memorial: ["Family", "Friends", "Colleagues"],
    }[key];
    // Blank every founding-page-specific default too, so a new page never inherits them.
    return { occasion: key, honoreeName: name, displayName: "", age: a || "", introText: intro,
      occasionTitle: "", thankYouText: "", eventDate: "", headerPhotoUrl: "", groups: groups || [] };
  }

  // -------------------- family archive (zip manifest) --------------------
  function safeName(s){ return String(s || "").replace(/[\\/:*?"<>|]+/g, " ").replace(/\s+/g, " ").trim().slice(0, 60) || "item"; }
  function extOf(url, kind){
    var u = String(url || "");
    var m = u.split("?")[0].match(/\.([a-z0-9]{2,5})$/i); if (m && !/^data:/.test(u)) return m[1].toLowerCase();
    m = u.match(/^data:(image|video|audio)\/([a-z0-9+.-]+)/i);
    if (m) { var sub = m[2].toLowerCase(); if (sub === "jpeg") return "jpg"; if (sub === "quicktime") return "mov"; if (sub === "mpeg") return "mp3"; return sub.replace(/[^a-z0-9]/g, "").slice(0, 4) || "bin"; }
    return kind === "photo" ? "jpg" : kind === "video" ? "mp4" : "m4a";
  }
  // Build the archive plan from the config + HYDRATED submissions: text files + a media fetch-list.
  // Pure (no fetch/zip here) so it's unit-testable; the view fetches media and zips.
  function archiveManifest(config, subs){
    var ap = (subs || []).filter(function(s){ return s.status === "approved"; });
    var songs = ap.filter(function(s){ return s.type === "song"; });
    var items = sortItems(ap.filter(function(s){ return s.type !== "song"; }));
    var honoree = config.displayName || config.honoreeName || "our honoree";
    var texts = [], media = [];
    var pad = function(n){ return (n < 10 ? "0" : "") + n; };
    var lines = [];
    items.forEach(function(s, idx){
      var who = s.name + (s.relationship ? " (" + s.relationship + ")" : "");
      var body = String(s.text || "").trim();
      if (!body && (s.type === "voice" || s.type === "video") && s.media && s.media[0]) body = String(s.media[0].caption || "").trim();   // transcript
      lines.push(pad(idx + 1) + ". " + who + (s.type !== "written" ? "  [" + s.type + "]" : ""));
      if (body) lines.push(body);
      lines.push("");
      (s.media || []).forEach(function(m, j){
        media.push({ path: "media/" + pad(idx + 1) + " - " + safeName(s.name) + ((s.media.length > 1) ? "-" + (j + 1) : "") + "." + extOf(m.url, m.kind), url: m.url });
      });
    });
    texts.push({ path: "messages.txt", text: "Messages & wishes for " + honoree + "\n========================================\n\n" + lines.join("\n") });
    if (config.essay) texts.push({ path: "tribute-essay.txt", text: config.essay });
    if (config.story && (config.story.opening || (config.story.chapters || []).length)) {
      var st = config.story, sl = [];
      if (st.opening) { sl.push(st.opening); sl.push(""); }
      (st.chapters || []).forEach(function(ch){ sl.push("— " + (ch.title || "") + " —"); if (ch.intro) sl.push(ch.intro); sl.push(""); });
      if (st.closing) sl.push(st.closing);
      texts.push({ path: "the-story.txt", text: sl.join("\n") });
    }
    if (config.narration) texts.push({ path: "opening-narration.txt", text: config.narration });
    var ms = sortMilestones(config.milestones || []);
    if (ms.length) texts.push({ path: "life-timeline.txt", text: ms.map(function(m){ return (m.year ? m.year + " — " : "") + (m.title || "") + (m.note ? "\n   " + m.note : ""); }).join("\n") });
    if (songs.length) texts.push({ path: "favorite-songs.txt", text: songs.map(function(s){ var sg = parseSong(s.text); return (sg.title || "") + (sg.artist ? " · " + sg.artist : "") + "  (picked by " + s.name + ")" + (sg.link ? "\n   " + sg.link : ""); }).join("\n") });
    if (config.honoreeReply && config.honoreeReply.kind === "written" && config.honoreeReply.text) texts.push({ path: "reply-from-" + safeName(honoree) + ".txt", text: config.honoreeReply.text });
    if (config.honoreeReply && (config.honoreeReply.kind === "video" || config.honoreeReply.kind === "voice") && config.honoreeReply.url) media.push({ path: "media/reply-from-" + safeName(honoree) + "." + extOf(config.honoreeReply.url, config.honoreeReply.kind === "video" ? "video" : "voice"), url: config.honoreeReply.url });
    revealSongs(config).forEach(function(sg){ media.push({ path: "songs/" + sg.file, url: sg.url }); });
    texts.unshift({ path: "README.txt", text:
      "The tribute for " + honoree + "\n" +
      "================================\n\n" +
      "This archive holds every approved message" + (media.length ? ", photo, video, and recording" : "") + " from the tribute,\n" +
      "so the family keeps a copy that outlives any website.\n\n" +
      "What's inside:\n" +
      "  messages.txt — every message (with transcripts of spoken ones)\n" +
      (config.essay ? "  tribute-essay.txt — the woven tribute essay\n" : "") +
      ((config.story && (config.story.chapters || []).length) ? "  the-story.txt — the chaptered story with narration\n" : "") +
      (ms.length ? "  life-timeline.txt — the life timeline\n" : "") +
      (songs.length ? "  favorite-songs.txt — the family playlist\n" : "") +
      (media.length ? "  media/ — all photos, videos, and voice recordings\n" : "") +
      "\nMessages: " + items.length + (media.length ? " · Media files: " + media.length : "") + "\n" });
    return { texts: texts, media: media };
  }

  // -------------------- export --------------------
  var API = {
    db: db,
    // pure helpers (exported for the view + node tests)
    TYPES: TYPES, STATUS: STATUS, TYPE_META: TYPE_META, LIMITS: LIMITS, SONGS_ON: SONGS_ON, REEL_ON: REEL_ON, WALL_ON: WALL_ON, CEREMONY_ON: CEREMONY_ON, MEMWALL_ON: MEMWALL_ON, AMBIENT_ON: AMBIENT_ON, GALLERY_SECTIONS_ON: GALLERY_SECTIONS_ON, ANIMATE_ON: ANIMATE_ON,
    validateGuest: validateGuest, validateItem: validateItem, fileSizeOk: fileSizeOk,
    canTransition: canTransition, hydrate: hydrate, approvedSubs: approvedSubs, sortItems: sortItems,
    groupApproved: groupApproved, revealMessages: revealMessages, photoWall: photoWall, statsOf: statsOf,
    buildReveal: buildReveal, publicLanding: publicLanding, blank: blank, defaultConfig: defaultConfig,
    uid: uid, token: token,
    writingPrompts: writingPrompts, normName: normName, matchContributors: matchContributors, contributorDirectory: contributorDirectory, allKnownEmails: allKnownEmails,
    validateBeta: validateBeta, contributorEmails: contributorEmails, parseInviteList: parseInviteList,
    OCCASIONS: OCCASIONS, occasionPreset: occasionPreset, ordinal: ordinal, ceremonyScript: ceremonyScript,
    parseSong: parseSong, songsList: songsList, sortMilestones: sortMilestones, storyGroups: storyGroups,
    safeName: safeName, extOf: extOf, archiveManifest: archiveManifest,
    RESERVED_SLUGS: RESERVED_SLUGS, slugify: slugify, validateSlug: validateSlug, validateShortWord: validateShortWord, occasionTemplate: occasionTemplate,
    revealMediaUrls: revealMediaUrls, expandPhotos: expandPhotos,
    slideDuration: slideDuration, tileExcerpt: tileExcerpt, filterTiles: filterTiles,
    TRAILER_DEF: TRAILER_DEF, sentences: sentences, pickQuote: pickQuote, buildTrailerPlan: buildTrailerPlan,
    clipSeconds: clipSeconds, trailerSeconds: trailerSeconds, fitTrailer: fitTrailer, fmtSecs: fmtSecs,
    applyDirectorCut: applyDirectorCut, cleanPops: cleanPops, reflowCaptions: reflowCaptions, splitCaptions: splitCaptions, trailerSequence: trailerSequence, bedReady: bedReady, bedOnScreen: bedOnScreen, bedAudio: bedAudio, trailerTracks: trailerTracks,
    revealSongs: revealSongs, songTitle: songTitle, fullRevealClips: fullRevealClips, openerLines: openerLines, stingerLines: stingerLines, withQuery: withQuery, linkFields: linkFields, revealPath: revealPath, defaultStinger: defaultStinger, openMusicLevel: openMusicLevel, openerBreaks: openerBreaks, parseOpenerLine: parseOpenerLine, openerDuration: openerDuration, openerPaced: openerPaced, findSilences: findSilences, syncCuesToVoice: syncCuesToVoice, cueDurations: cueDurations, defaultOpener: defaultOpener, trailerSlots: trailerSlots, slotName: slotName, slotTitleKey: slotTitleKey, slotTitleUrlKey: slotTitleUrlKey, slotTitleLive: slotTitleLive, slotByKey: slotByKey, slotBy: slotBy, SONG_SLOTS: SONG_SLOTS, songsBeforeBed: songsBeforeBed, slotTrim: slotTrim, trailerTrackList: trailerTrackList, musicTimeline: musicTimeline, duckLevel: duckLevel,
  };
  if (typeof module !== "undefined" && module.exports) module.exports = API;
  if (typeof window !== "undefined") root.APP = API;
})(typeof window !== "undefined" ? window : this);

export const APP = module.exports;
export default APP;
